<template>
  <a-config-provider :locale="locale">

  <div id="app">


  <a-layout style=" min-width:1340px;">


    <a-layout-header class="header" style="padding-left:0px; padding-right:8px">
     
     <div style="float:right;margin-right:10px">
        <template v-if="user.isLogin==1">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <a-icon type="user" /> {{user.nickName}} <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a target="_blank" rel="noopener" href="https://2weima.com/user/kcx.html"><a-icon type="html5" /> 我的作品</a>
              </a-menu-item>
              <a-menu-item>
                <a target="_blank" rel="noopener" href="https://2weima.com/user.html"><a-icon type="user" /> 用户中心</a>
              </a-menu-item>
              <a-menu-divider />
              <a-menu-item>
                <a target="_blank" rel="noopener" href="https://www.2weima.com/user/logout.html"><a-icon type="logout" /> 退出登陆</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <template v-else>
          <a-space>
            <a href="https://www.2weima.com/user/login.html?source=h5editor" rel="noopener" target="_blank"><a-icon type="user" />登陆</a>
            <a href="https://www.2weima.com/user/register.html?source=h5editor" rel="noopener" target="_blank"><a-icon type="plus" />注册</a>
          </a-space>
        </template>
      </div>



      <a-menu
        theme="dark"
        mode="horizontal"
        :selectable="false"
        :default-selected-keys="['index']"
        :style="{ lineHeight: '64px',maxWidth:'400px' }"
      >
        <a-menu-item key="index">
          开场秀
        </a-menu-item>
        <a-menu-item key="new" title="新建空白开场秀">
            <a href="/kcx.html" target="_blank">新建</a>
        </a-menu-item>
        <a-menu-item key="template" title="开场秀模板">
          <a href="/h5.html" target="_blank">模板</a>
        </a-menu-item>
      </a-menu>


      
    </a-layout-header>
    <a-layout-content >
      <div style="float:right; margin-top:10px; margin-right:16px;">
        <a-button-group>
          <a-icon type="qrcode" style="font-size:30px;margin-right:8px;color:#40a9ff" title="查看二维码" @click="onShowQrcode" v-if="saveRes.code==1"/>
          <a-button type="default" @click="onXiuSetting"> <a-icon type="setting" /> 开场秀设置</a-button>
          <a-button type="danger" @click="onPreviewH5"> <a-icon type="play-circle" /> 预览 {{previewSetting.count >0 ? previewSetting.count :　''}}</a-button>
          <a-dropdown-button type="primary" @click="onSaveXiu('save')">
            <a-icon type="cloud" /> 保存发布
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item key="save_new"> <a-icon type="html5" />另存为新的开场秀 </a-menu-item>
            </a-menu>
          </a-dropdown-button>

        </a-button-group>
      </div>
      <a-breadcrumb style="margin: 16px">
        <a-breadcrumb-item><a href="https://www.2weima.com/" rel="noopener" target="_blank">二维工坊</a></a-breadcrumb-item>
        <a-breadcrumb-item>{{xiuSetting.share.title}}</a-breadcrumb-item>
      </a-breadcrumb>

      <a-layout style="padding: 0px; height:100%; position: relative; ">
        <a-layout-sider class="h5-left-sider" width="400" >


          <a-tabs default-active-key="text" tabPosition="left">
            <a-tab-pane key="text" tab="文本">
              <div class="row-space">
                <h4>文本小部件</h4>
                <a-button type="dashed" block @click="onLeftSiderSuCaiText('empty')"> <a-icon type="plus" />添加到页面</a-button>
              </div>

              <div class="row-space">
                <div>素材主色</div>
                <a-input placeholder="素材主色" type="color" v-model="diyStyle.primaryColor" style="padding:0 4px;"></a-input>
              </div>

              <a-divider />


              <h4><a-icon type="build" /> 标题素材</h4>
              <template v-for="(item,index) in diyStyleTitle">
                <div title="点击添加到页面" :key="'stitle_'+index" v-html="item" @click="onLeftSiderSuCaiText('title',index)"></div>
              </template>

              <h4><a-icon type="build" /> 内容素材</h4>
              <template v-for="(item,index) in diyStyleText">
                <div title="点击添加到页面" :key="'stext_'+index" v-html="item" @click="onLeftSiderSuCaiText('text',index)"></div>
              </template>

              <h4><a-icon type="build" /> 表格素材</h4>
              <template v-for="(item,index) in diyStyleTable">
                <div title="点击添加到页面" :key="'stable_'+index" v-html="item" @click="onLeftSiderSuCaiText('table',index)"></div>
              </template>



            </a-tab-pane>
            <a-tab-pane key="chahua" tab="插画">
              <h4>图片小部件</h4>
              <a-button type="dashed" block @click="addWidgetToPage('image')"> <a-icon type="plus" />添加到页面</a-button>
              
              <a-divider />
              <h4><a-icon type="build" /> 人物素材</h4>
              <a-collapse :bordered="false" :accordion="true">
                <template v-for="(renwuItem,renwuIndex) in diyStyle.renwu">
                <a-collapse-panel :header="diyStyle.imageSuCaiType[renwuIndex]" :key="renwuIndex">
                     <template v-for="(item,index) in renwuItem">
                    <div class="sucai-image" title="点击添加到页面" :key="renwuIndex + index" @click="onLeftSiderSuCaiImage(item)">
                      <img :src="item.url"/>
                      <p>{{item.title}}</p>
                    </div>
                    </template>
                </a-collapse-panel>
                </template>
              </a-collapse>


              <h4 style="margin-top:16px;"><a-icon type="build" /> 图标素材</h4>
              <a-collapse :bordered="false" :accordion="true">
                <template v-for="(tubiaoItem,tubiaoIndex) in diyStyle.tubiao">
                <a-collapse-panel :header="diyStyle.imageSuCaiType[tubiaoIndex]" :key="tubiaoIndex">
                     <template v-for="(item,index) in tubiaoItem">
                    <div class="sucai-image" title="点击添加到页面" :key="tubiaoIndex + index" @click="onLeftSiderSuCaiImage(item)">
                      <img :src="item.url" style="width:64px" />
                      <p>{{item.title}}</p>
                    </div>
                    </template>
                </a-collapse-panel>
                </template>

              </a-collapse>

              <div style="margin-top:16px;" >
                <a-alert message="图片素材来源于阿里Hitu、Humaaans等免费可商用插画，可放心使用" type="info" show-icon />
              </div>

            </a-tab-pane>

            <a-tab-pane key="image" tab="图片">
              <h4>图片小部件</h4>
              <a-button type="dashed" block @click="addWidgetToPage('image')"> <a-icon type="plus" />添加到页面</a-button>
              
              <a-divider />
              <h4><a-icon type="build" /> 节日素材</h4>
              <a-collapse :bordered="false" :accordion="true">
                <template v-for="(ccoItem,ccoIndex) in diyStyle.cco">
                <a-collapse-panel :header="diyStyle.imageSuCaiType[ccoIndex]" :key="ccoIndex">
                     <template v-for="(item,index) in ccoItem">
                    <div class="sucai-image" title="点击添加到页面" :key="ccoIndex + index" @click="onLeftSiderSuCaiImage(item)">
                      <img :src="item.url" />
                      <p>{{item.title}}</p>
                    </div>
                    </template>
                </a-collapse-panel>
                </template>
              </a-collapse>


              <div style="margin-top:16px;" >
                <a-alert message="图片素材来源于pixabay、pexels等CC0协议素材，可放心使用" type="info" show-icon />
              </div>

            </a-tab-pane>
          </a-tabs>




        </a-layout-sider>
        <a-layout-content  :class="'h5-workarea simulator-'+ xiuSetting.simulator" :style="{minWidth : xiuSetting.width+150 + 'px'}">
            
          <div  class="h5-pageview" >
            <div style="margin-left:5px;font-size:12px;color:#666">{{activePage.title}} 设计中...</div>

            <div class="h5-simulator" :style="{zIndex:0,pointerEvents: 'none',background:activePage.bgColor + (activePage.widgetList.length > 0 ? '' : ' url(/static/images/h5editor/h5bg.png) no-repeat center center')}">
              <!-- 背景色 -->
            </div>
            
            <div class="h5-simulator" :style="{zIndex:100,pointerEvents: 'none'}" v-if="xiuSetting.simulator=='phone'">
              <!-- 全屏辅助线 -->
              <span class="simulator-name">全面屏</span>
              <span class="simulator-name_md">主流屏</span>
              <span class="simulator-name_sm">常规屏
                <div style="margin-top:8px; color:#f30">主流屏内容区</div>
                <div style="margin-top:24px; color:#52c41a">最佳内容区</div>
                <div style="margin-top:24px; color:#bbb">超出内容区的信息在小屏幕中显示不全</div>
              </span>
              <div class="h5-simulator_md">
                <div class="h5-simulator_sm">
                  <!-- 辅助 -->
                </div>
              </div>
            </div>

            <div class="h5-pagemain" :style="{zIndex:100,pointerEvents: 'none'}" v-if="xiuSetting.simulator=='phone'">
               <!-- 内容辅助线 -->
              <div class="h5-pagemain_md">
                <div class="h5-pagemain_sm">
                </div>
              </div>
            </div>


            <div class="h5-pagemain" :style="{zIndex:20}">
              <div class="h5-pagemain_md">
                <div class="h5-pagemain_sm">
                 
                  <template v-if="activePage.widgetList.length>0">
                  <template v-for="(widgetItem,widgetIndex) in activePage.widgetList">
               
                        <vue-draggable-resizable 
                          :key="widgetItem.name + '_' + widgetIndex"
                          :active="activeWidgetIndex == widgetIndex"
                          :class="activeWidgetIndex == widgetIndex ? '' : 'border-none'"
                          :w="widgetItem.box.width" 
                          :h="widgetItem.box.height" 
                          :x="widgetItem.box.x" 
                          :y="widgetItem.box.y" 
                          :r="widgetItem.box.rotate"
                          :z="activePage.widgetList.length - widgetIndex"
                          :lockAspectRatio="widgetItem.draggable.lockAspectRatio"
                          :rotatable="true" 
                          :draggable ="true" 
                          :resizable="true" 
                          :snap="true"
                          :snapTolerance="5"
                          @refLineParams="getRefLineParams"
                          @dragstop="onDragStop" 
                          @resizing="onResizeStop"
                          @rotatestop="onRotateStop" 
                          @activated="onActivated(widgetIndex)"
                          @deactivated="onDeactivated" 
                        >
                          <a-dropdown :trigger="['contextmenu']">
                            <a-menu slot="overlay" @click="onRightKeyClick($event,widgetIndex)">
                              <a-menu-item key="none">
                               不操作
                              </a-menu-item>
                              <a-menu-item key="lockAspectRatio">
                                <a-icon :type="widgetItem.draggable.lockAspectRatio ? 'unlock' : 'lock'" /> {{widgetItem.draggable.lockAspectRatio ? '取消固定比例缩放' : '固定比例缩放'}}
                              </a-menu-item>
                              <a-menu-item key="setting">
                                <a-icon type="setting" /> 内容设置
                              </a-menu-item>
                              <a-menu-item key="copy">
                               <a-icon type="copy" /> 复制
                              </a-menu-item>
                              <a-menu-item key="delete">
                               <a-icon type="close-circle" /> 删除
                              </a-menu-item>
                              
                             
                            </a-menu>

                            <div :class="animate2class(widgetItem.animatePlay,widgetIndex,activePageIndex)" :style="animate2style(widgetItem.animatePlay)">
                              <template v-if="widgetItem.name=='text'">
                                <span v-html="widgetItem.content"></span>
                              </template>
                              <template v-else-if="widgetItem.name=='image'">
                                <img :src="widgetItem.src" :style="{width:widgetItem.box.width-2 + 'px',height:widgetItem.box.height-2 + 'px',opacity:widgetItem.box.opacity/100}"/>
                              </template>
                            </div>
                          </a-dropdown>
                        </vue-draggable-resizable>
  
                  </template>

  

                  </template>
                  
                  <!-- 对齐线 -->
                  <span class="ref-line v-line" v-for="(item,index) in resizable.vLine" :key="'v_'+index" v-show="item.display" :style="{ left: item.position, top: item.origin, height: item.lineLength}" />
                  <span class="ref-line h-line"  v-for="(item,index) in resizable.hLine" :key="'h_'+index" v-show="item.display" :style="{ top: item.position, left: item.origin, width: item.lineLength}" />



                </div>
              </div>
            </div>
            
          </div>

          <div class="h5editor-copyright">Copyright © 2weima.com All Rights Reserved. </div>
        </a-layout-content>
        <a-layout-sider class="h5-right-sider" width="470" >
          

          <a-tabs v-model="rightSiderActiveKey" tabPosition="left" @change="onRightSiderChange">
          

            <a-tab-pane key="page" tab="页面">

              <h4 :style="{marginTop:16+'px'}">页面设置</h4>
              <draggable v-model="pageList" @start="drag=true" @end="drag=false" @change="onPageDrag" handle=".mover">

                  <div v-for="(pageItem,pageIndex) in pageList" :key="pageIndex" :style="{marginTop:16+'px'}">
                    <a-card :style="activePageIndex==pageIndex ? 'border:1px solid #40a9ff;' : ''" @click="onPageSelect(pageIndex)">
                      <div slot="title">
                        <a-input placeholder="页面标题" style="width:92%" v-model="pageItem.title">
                          <span slot="prefix">{{pageIndex+1}}</span>
                        </a-input>
                      </div>
                      <a slot="extra" href="javascript:;"  class="mover" style="cursor: move;" title="拖动改变页面顺序"><a-icon type="drag" /></a>

                      <template v-if="activePageIndex==pageIndex" >
                        <div class="row-space">
                          <div>背景色</div>
                          <a-input placeholder="页面标题" type="color" v-model="pageItem.bgColor" style="padding:0 4px;"></a-input>
                        </div>
                        <div class="row-space">
                          <div>页面停留时间（自动播放时）</div>
                          <a-input-number id="inputNumber" v-model="pageItem.duration" :min="1" :max="600"/> 秒
                        </div>


                        <div style="text-align:right;margin-top:24px;">
                          <a-space>
                            <a-button type="dashed" icon="sort-descending" size="small" @click.stop="onRightSiderChange('layer')">图层设置</a-button>
                            <a-popconfirm title="复制到新页面?" placement="topRight" @confirm="onPageCopy">
                              <a-button type="dashed" icon="copy" size="small">复制</a-button>
                            </a-popconfirm>
                            <a-popconfirm title="确定删除本页面吗?" placement="topRight" @confirm="onPageDelete">
                              <a-button type="dashed" icon="close" size="small">删除</a-button>
                            </a-popconfirm>
                          </a-space>
                        </div>
                      </template>

                    </a-card>
                  </div>
              
							</draggable>

              <a-button type="dashed" icon="plus" block :style="{marginTop:16+'px'}" @click="onPageAdd">
                添加一页
              </a-button>
  


              
            </a-tab-pane>
          
            <a-tab-pane key="layer" tab="图层">
              <h4>小部件层级设置</h4>
              
              <template v-if="activePage.widgetList.length==0">
                <a-alert message="先添加小部件到页面再进行设置" banner />
              </template>
              <template v-else>
                <div>
                  <a-icon type="sort-descending" /> 拖动改变顺序来调整小部件层级防止遮挡
                </div>
                <draggable v-model="activePage.widgetList" @change="onWidgetDrag" handle=".mover">

                    <div v-for="(widgetItem,widgetIndex) in activePage.widgetList" :key="widgetIndex" :style="{marginTop:16+'px'}">
                      <a-card :style="activeWidgetIndex==widgetIndex ? 'border:1px solid #40a9ff;' : ''" @click="onWidgetSelect(widgetIndex)">
                        <div slot="title">
                          <a-input placeholder="小部分名称" style="width:92%" v-model="widgetItem.title">
                            <span slot="prefix">{{activePage.widgetList.length - widgetIndex}}</span>
                          </a-input>
                        </div>
                        <a slot="extra" href="javascript:;"  class="mover" style="cursor: move;" title="拖动改变图层顺序"><a-icon type="drag" /></a>

                        <template v-if="activeWidgetIndex==widgetIndex" >
                        
                          <div style="text-align:right">
                            <a-space>
                              <a-button type="dashed" icon="setting" size="small" @click.stop="onRightSiderChange('widget')">内容设置</a-button>
                              <a-popconfirm title="复制一个小部件?" placement="topRight" @confirm="onWidgetCopy">
                              <a-button type="dashed" icon="copy" size="small">复制</a-button>
                            </a-popconfirm>
                              <a-popconfirm title="确定删除小部件吗?" placement="topRight" @confirm="onWidgetDelete">
                                <a-button type="dashed" icon="close" size="small">删除</a-button>
                              </a-popconfirm>
                            </a-space>
                          </div>
                        </template>

                      </a-card>
                    </div>
                
                </draggable>
              </template>

              
            </a-tab-pane>
            <a-tab-pane key="widget" tab="内容">
              <h4>小部件设置</h4>
              <template v-if="activeWidgetIndex==null">
                <a-alert message="在页面中点击要设置的小部件,再来看看吧" banner />
              </template>
              <template v-else>

                <template v-if="activeWidget.name=='text'">
                  <textarea id="diy-ueditor" v-html="activeWidget.content"></textarea>
                </template>
                <template v-else-if="activeWidget.name=='image'">

    
                  <div class="ant-upload ant-upload-select ant-upload-select-picture-card" style="float:none" @click="onImageSelectOpen('widget')">
                    <div class="ant-upload">
                       <div v-if="activeWidget.src">
                         <img :src="activeWidget.src" alt="image" style="max-width:320px" />
                      </div>
                      <div style="margin-top:8px">
                        <!-- <a-icon type="picture"/> -->
                        <div class="ant-upload-text">
                          选择图片
                        </div>
                      </div>
                    </div>

                  </div>

                  <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                      <a-col class="gutter-row" :span="12" >
                        <div>图片宽度</div>
                        <a-input-number v-model="activeWidget.box.width" :min="0"  :step="1" @change="onImageSizeChange($event,'width')" /> px
                      </a-col>

                      <a-col class="gutter-row" :span="12" >
                        <div>图片高度</div>
                        <a-input-number v-model="activeWidget.box.height" :min="0"  :step="1" @change="onImageSizeChange($event,'height')" /> px
                      </a-col>

                      <a-col class="gutter-row" :span="23" >
                        <div>透明度</div>
                        <a-slider v-model="activeWidget.box.opacity" />
                      </a-col>
                    </a-row>

                  
                </template>

                <a-divider />

                <h4 style="margin-top:16px;"><a-icon type="number" spin /> 小部件动作</h4>
            
              
                <a-tabs default-active-key="1" tabPosition="top">
                  <a-tab-pane key="1" tab="入场" force-render>
                    
                    <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                      <a-col class="gutter-row" :span="12" >
                        <div>动画时长</div>
                        <a-input-number v-model="activeWidget.animate.in.duration" :min="0" :max="10" :step="0.1" @change="activeWidget.animate.in.duration = parseToFixed1($event)" /> 秒
                      </a-col>

                      <a-col class="gutter-row" :span="12" >
                        <div>延时执行</div>
                        <a-input-number v-model="activeWidget.animate.in.delay" :min="0" :max="10" :step="0.1" @change="activeWidget.animate.in.delay = parseToFixed1($event)" /> 秒
                      </a-col>

                      <a-col class="gutter-row" :span="24" >
                        <div>播放次数</div>
                        <a-input-number v-model="activeWidget.animate.in.loop" :disabled="activeWidget.animate.in.loop==0" :min="0" :max="100" :step="1"/> 次

                        <a-checkbox :checked="activeWidget.animate.in.loop==0" @change="activeWidget.animate.in.loop = $event.target.checked ? 0 : 1" :style="{marginLeft:'16px'}">
                          无限(无中场动画时)
                        </a-checkbox>
                      </a-col>
                    </a-row>

                    <a-divider />

                    <template v-for="(item,index) in animateCss">
                    <div :key="index" v-if="item.type =='in'">
                      <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                        <a-col class="gutter-row" :span="24" >
                        <div>{{item.title}}</div>
                        </a-col>
                        <a-col class="gutter-row" :span="6" v-for="(val,idx) in item.list" :key="idx">
                            <a-button :type="activeWidget.animate.in.name == val.css ? 'primary': 'default' " :icon="val.icon" @click="onAnimateTaggle(val.css,'in')">
                              {{val.title}}
                            </a-button>
                        </a-col>
                      </a-row>
                    </div>
                    </template>


                  </a-tab-pane>
                  <a-tab-pane key="2" tab="中场">

                    <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                      <a-col class="gutter-row" :span="12" >
                        <div>动画时长</div>
                        <a-input-number v-model="activeWidget.animate.middle.duration" :min="0" :max="10" :step="0.1" @change="activeWidget.animate.middle.duration = parseToFixed1($event)" /> 秒
                      </a-col>

                      <a-col class="gutter-row" :span="12" >
                        <div>延时执行</div>
                        <a-input-number v-model="activeWidget.animate.middle.delay" :min="0" :max="10" :step="0.1" @change="activeWidget.animate.middle.delay = parseToFixed1($event)" /> 秒
                      </a-col>

                      <a-col class="gutter-row" :span="24" >
                        <div>播放次数</div>
                        <a-input-number v-model="activeWidget.animate.middle.loop" :disabled="activeWidget.animate.middle.loop==0" :min="0" :max="100" :step="1"/> 次

                        <a-checkbox :checked="activeWidget.animate.middle.loop==0" @change="activeWidget.animate.middle.loop = $event.target.checked ? 0 : 1" :style="{marginLeft:'16px'}">
                          无限
                        </a-checkbox>
                      </a-col>
                    </a-row>

                    <a-divider />


                    <template v-for="(item,index) in animateCss">
                    <div :key="index" v-if="item.type =='middle'">
                      <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                        <a-col class="gutter-row" :span="24" >
                        <div>{{item.title}}</div>
                        </a-col>
                        <a-col class="gutter-row" :span="6" v-for="(val,idx) in item.list" :key="idx">
                            <a-button :type="activeWidget.animate.middle.name == val.css ? 'primary': 'default' " :icon="val.icon" @click="onAnimateTaggle(val.css,'middle')">
                              {{val.title}}
                            </a-button>
                        </a-col>
                      </a-row>
                    </div>
                    </template>

                    <a-alert style="margin:8px 0" message="下面是出场动画，出场后消失，通常配合廷时执行让内容出现N秒就消失掉" type="info" show-icon />

                    <template v-for="(item,index) in animateCss">
                      <div :key="'m_out'+index" v-if="item.type =='out' && index>=3">
                        <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                          <a-col class="gutter-row" :span="24" >
                          <div>{{item.title}} 出场</div>
                          </a-col>
                          <a-col class="gutter-row" :span="6" v-for="(val,idx) in item.list" :key="idx">
                              <a-button :type="activeWidget.animate.middle.name == val.css ? 'primary': 'default' " :icon="val.icon" @click="onAnimateTaggle(val.css,'middle')">
                                {{val.title}}
                              </a-button>
                          </a-col>
                        </a-row>
                      </div>
                      </template>

                  </a-tab-pane>
                  <a-tab-pane key="3" tab="点击">
                    <div :style="{ marginTop: '16px' }">
                      <a-radio-group default-value="none" v-model="activeWidget.clickAction.action">
                        <a-radio :style="verticalRadioStyle" value="none">
                          无动作
                        </a-radio>
                        <a-radio :style="verticalRadioStyle" value="page">
                          切换页面
                        </a-radio>
                        <a-radio :style="verticalRadioStyle" value="link">
                          跳转链接
                        </a-radio>
                        <a-radio :style="verticalRadioStyle" value="tel">
                          拔打电话
                        </a-radio>
                        <a-radio :style="verticalRadioStyle" value="message">
                          消息提示
                        </a-radio>
                      </a-radio-group>
                    </div>

                    <div :style="{ marginTop: '16px' }" v-if="activeWidget.clickAction.action =='tel'">
                      <a-divider>电话设置</a-divider>
                      <div>拔打电话</div>
                      <a-input v-model="activeWidget.clickAction.tel" >
                        <a-icon slot="prefix" type="phone" />
                      </a-input>
                    </div>
                     <div :style="{ marginTop: '16px' }" v-if="activeWidget.clickAction.action =='message'">
                      <a-divider>消息提示</a-divider>
                      <div>消息内容</div>
                      <a-input v-model="activeWidget.clickAction.message" >
                        <a-icon slot="prefix" type="sound" />
                      </a-input>
                    </div>

                    <div :style="{ marginTop: '16px' }" v-else-if="activeWidget.clickAction.action =='link'">
                      <a-divider>链接设置</a-divider>
                      <div>跳转链接</div>
                      <!-- <a-input v-model="activeWidget.clickAction.link.link" placeholder="如：https://www.2weima.com/">
                        <a-icon slot="prefix" type="link" />
                        <a-icon  type="share-alt" title="选择" /> 
                      </a-input> -->
                      <a-input-search
                        placeholder="如：https://www.2weima.com/"
                        enter-button="选择"
                        v-model="activeWidget.clickAction.link.link"
                        @search="onActionLinkOpen"
                      >
                      <a-icon slot="prefix" type="link" />
                      </a-input-search>

                      <div :style="{ marginTop: '16px' }" >小程序页面路径</div>
                      <a-input v-model="activeWidget.clickAction.link.path" placeholder="如：pages/index/index?foo=bar">
                        <a-icon slot="prefix" type="wechat" />
                      </a-input>
                      <div :style="{ marginTop: '16px' }" >小程序appId</div>
                      <a-input v-model="activeWidget.clickAction.link.appId" placeholder="如：wx81bdf0b17a44370d">
                        <a-icon slot="prefix" type="wechat" />
                      </a-input>

                      <a-alert :style="{ marginTop: '16px' }" message="H5打开时：跳转链接，小程序打开时：跳转路径" type="info" show-icon />

                    </div>
                    <div :style="{ marginTop: '16px' }" v-if="activeWidget.clickAction.action =='page'">
                      <a-divider>切换页面</a-divider>
                    
                       <a-radio-group v-model="activeWidget.clickAction.page.index" >
                          <template v-for="(pageItem,pageIndex) in pageList">
                            <a-radio :style="verticalRadioStyle"  :key="pageIndex"  :value="pageIndex" :disabled="activePageIndex ==pageIndex">
                              {{pageItem.title}} {{activePageIndex ==pageIndex? "（当前页）":""}}
                            </a-radio>
                          </template>
                        </a-radio-group>
                      
                    </div>

                    <div :style="{ marginTop: '16px' }" v-if="activeWidget.clickAction.action =='none' || activeWidget.clickAction.action =='tel' || activeWidget.clickAction.action =='message'">

                      <a-divider>触发动画</a-divider>

                      <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                        <a-col class="gutter-row" :span="12" >
                          <div>动画时长</div>
                          <a-input-number v-model="activeWidget.animate.click.duration" :min="0" :max="10" :step="0.1" @change="activeWidget.animate.click.duration = parseToFixed1($event)" /> 秒
                        </a-col>

                        <a-col class="gutter-row" :span="12" >
                          <div>延时执行</div>
                          <a-input-number v-model="activeWidget.animate.click.delay" :min="0" :max="10" :step="0.1" @change="activeWidget.animate.click.delay = parseToFixed1($event)" /> 秒
                        </a-col>

                        <a-col class="gutter-row" :span="24" >
                          <div>播放次数</div>
                          <a-input-number v-model="activeWidget.animate.click.loop" :disabled="activeWidget.animate.click.loop==0" :min="0" :max="100" :step="1"/> 次

                          <a-checkbox :checked="activeWidget.animate.click.loop==0" @change="activeWidget.animate.click.loop = $event.target.checked ? 0 : 1" :style="{marginLeft:'16px'}">
                            无限
                          </a-checkbox>
                        </a-col>
                      </a-row>

                      <a-divider />


                      <template v-for="(item,index) in animateCss">
                      <div :key="index" v-if="item.type =='click' || index>=3">
                        <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                          <a-col class="gutter-row" :span="24" >
                          <div>{{item.title}} {{item.type=="in"?"入场": item.type=="out"? "出场":""}}</div>
                          </a-col>
                          <a-col class="gutter-row" :span="6" v-for="(val,idx) in item.list" :key="idx">
                              <a-button :type="activeWidget.animate.click.name == val.css ? 'primary': 'default' " :icon="val.icon" @click="onAnimateTaggle(val.css,'click')">
                                {{val.title}}
                              </a-button>
                          </a-col>
                        </a-row>
                      </div>
                      </template>

                  </div>

                  </a-tab-pane>
                  <a-tab-pane key="4" tab="出场">

                    <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                      <a-col class="gutter-row" :span="12" >
                        <div>动画时长</div>
                        <a-input-number v-model="activeWidget.animate.out.duration" :min="0" :max="10" :step="0.1" @change="activeWidget.animate.out.duration = parseToFixed1($event)" /> 秒
                      </a-col>

                      <a-col class="gutter-row" :span="12" >
                        <div>延时执行</div>
                        <a-input-number v-model="activeWidget.animate.out.delay" :min="0" :max="10" :step="0.1" @change="activeWidget.animate.out.delay = parseToFixed1($event)" /> 秒
                      </a-col>

                      <a-col class="gutter-row" :span="24" >
                        <div>播放次数</div>
                        <a-input-number v-model="activeWidget.animate.out.loop" :disabled="true" :min="0" :max="100" :step="1"/> 次

                      </a-col>
                    </a-row>

                    <a-divider />
                    
                    <template v-for="(item,index) in animateCss">
                    <div :key="index" v-if="item.type =='out'">
                      <a-row :gutter="[4,4]" :style="{marginBottom:'16px'}">
                        <a-col class="gutter-row" :span="24" >
                        <div>{{item.title}}</div>
                        </a-col>
                        <a-col class="gutter-row" :span="6" v-for="(val,idx) in item.list" :key="idx">
                            <a-button :type="activeWidget.animate.out.name == val.css ? 'primary': 'default' " :icon="val.icon" @click="onAnimateTaggle(val.css,'out')">
                              {{val.title}}
                            </a-button>
                        </a-col>
                      </a-row>
                    </div>
                    </template>

                  </a-tab-pane>

                </a-tabs>
              </template>

                
              </a-tab-pane>

            </a-tabs>

        


         

 
     

        </a-layout-sider>
      </a-layout>
    </a-layout-content>

    <!-- <a-affix :offset-bottom="0" style="width:100%">
      <a-layout-footer style="text-align: left; background:#fff; height:30px; overflow-y:scroll; border-top:2px solid #1890ff; padding:10px 42px;">
footer
      </a-layout-footer>
    </a-affix> -->
  </a-layout>


<!-- 秀设置 -->
<a-drawer
  title="开场秀设置"
  placement="right"
  :body-style="{ paddingBottom: '80px' }"
  :width="500"
  :closable="false"
  :visible="xiuSetting.isActive"
  @close="onXiuSettingClose"
>

  <div style="margin-bottom:16px;">
    <h4><a-icon type="customer-service" /> 背景音乐</h4>
    <a-tag closable @close="onBgSoundClear" v-if="pageBgSound.file_url && pageBgSound.file_url !=''">
      {{pageBgSound.name}}
    </a-tag>
    <div class="row-space">
      <a-button type="dashed" icon="customer-service" block :style="{marginTop:8+'px'}" @click="onBgSoundOpen">
        选择音乐
      </a-button>
    </div>
  </div>
  <div style="margin-bottom:16px;">
    <h4><a-icon type="share-alt" /> 自定义分享设置</h4>

    <a-row :gutter="[4,4]"  class="row-space" >
      <a-col class="gutter-row" :span="8" >
        
        <div class="ant-upload ant-upload-select ant-upload-select-picture-card" style="float:none" @click="onImageSelectOpen('share')">
          <div class="ant-upload" title="点击换图">
            <div v-if="xiuSetting.share.cover">
                <img :src="xiuSetting.share.cover" alt="image" style="max-width:110px" />
            </div>
            <div v-else>
              <img src="/static/images/h5editor/share_cover.jpg" alt="image" style="max-width:110px" />
              <!-- <a-icon type="picture" :style="{fontSize:'64px',color:'#ccc'}"/> -->
              <div class="ant-upload-text">
                选择图片
              </div>
            </div>
          </div>

        </div>

        
      </a-col>
      <a-col class="gutter-row" :span="16" >
        <div style="margin-bottom:8px;">
          <div>作品标题</div>
          <a-input placeholder="作品标题" v-model="xiuSetting.share.title"/>
        </div>
        <div style="margin-bottom:8px;">
          <div>分享描述</div>
          <a-input placeholder="分享描述" v-model="xiuSetting.share.desc"/>
        </div>
      </a-col>
    </a-row>



  </div>

  <div style="margin-bottom:16px;">
    <h4><a-icon type="lock" /> 访问控制</h4>
    <div class="row-space">
      <div>访问密码</div>
      <a-input-password placeholder="访问密码,不设置请留空" v-model="xiuSetting.pwd"/>
    </div>
    <div class="row-space">
      <div>最大扫码次数</div>
      <a-input-number v-model="xiuSetting.maxViews" :min="0" /> 设置 0 为无限制
    </div>

    <div class="row-space">
      <div>开放时间</div>
      <a-date-picker show-time v-model="xiuSetting.startTime" @ok="onStartTimeOk"></a-date-picker>
    </div>
     <div class="row-space">
      <div>结束时间</div>
      <a-date-picker show-time v-model="xiuSetting.endTime" @ok="onEndTimeOk"></a-date-picker>
    </div>

  </div>
  <div style="margin-bottom:16px;">
    <h4><a-icon type="play-circle" /> 播放控制</h4>
    <div class="row-space">
      <div>显示进度（底部进度条）</div>
      <a-switch checked-children="开" un-checked-children="关" v-model="xiuSetting.playController.showProgress" />
    </div>
    <div class="row-space">
      <div>显示控制按钮（左下角上下翻页按钮）</div>
      <a-switch checked-children="开" un-checked-children="关" v-model="xiuSetting.playController.showCtrlBtn" />
    </div>
    <div class="row-space">
      <div>自动播放（根据页面停留时间自动翻页）</div>
      <a-switch checked-children="开" un-checked-children="关" v-model="xiuSetting.playController.autoPlay" />
    </div>
    <div class="row-space" v-if="xiuSetting.playController.autoPlay">
      <div>默认播放状态</div>
      <a-switch checked-children="播放" un-checked-children="暂停" v-model="xiuSetting.playController.defaultPlaying" />
    </div>
    <div class="row-space" v-if="xiuSetting.playController.autoPlay">
      <div>播放次数</div>
      <a-input-number v-model="xiuSetting.playController.loop" :min="0" /> 设置 0 为无限制
    </div>
    <div class="row-space">
      <div>禁止滑动翻页（禁止后可使用控制按钮/自动播放进行翻页）</div>
      <a-switch checked-children="开" un-checked-children="关" v-model="xiuSetting.playController.notSwipe" />
    </div>
    

  </div>
  <a-divider/>

  <div style="margin-bottom:16px;">
    <h4><a-icon type="gateway" /> 适用尺寸</h4>
    

    <div class="row-space">
      <a-radio-group v-model="xiuSetting.simulator" @change="onXiuSettingSimulatorChange">
        <a-radio-button value="phone">
          手机 phone
        </a-radio-button>
        <a-radio-button value="pad">
          平板 pad
        </a-radio-button>
        <a-radio-button value="pc">
          电脑 pc
        </a-radio-button>
        <!-- <a-radio-button value="custom">
          自定义
        </a-radio-button> -->
      </a-radio-group>
    </div>
    <div class="row-space">
      <div>最佳内容区：宽度 x 高度 （超出内容区的信息在小屏幕中显示不全）</div>
      <a-input-number v-model="xiuSetting.width" :min="300" :disabled="xiuSetting.simulator!='custom'" /> x <a-input-number v-model="xiuSetting.height" :min="300" :disabled="xiuSetting.simulator!='custom'" />
    </div>

    

  </div>






  <div
    :style="{
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1,
    }"
  >
    <a-button type="primary" @click="onXiuSettingClose">收起<a-icon type="right" /> </a-button>
  </div>
  


</a-drawer>



<a-modal v-model="previewSetting.isActive" title="预览" @ok="onPreviewH5Close" @cancel="onPreviewH5Close" width="80%">

      <div style="margin-bottom:10px; text-align:center;">
        <a-button-group v-if="xiuSetting.simulator=='phone'">
          <a-button @click="onTogglePVS('simulator_lg')" :type="previewSetting.simulator=='simulator_lg' ? 'primary' : 'default'">全面屏</a-button>
          <a-button @click="onTogglePVS('simulator_md')" :type="previewSetting.simulator=='simulator_md' ? 'primary' : 'default'">主流屏</a-button>
          <a-button @click="onTogglePVS('simulator_sm')" :type="previewSetting.simulator=='simulator_sm' ? 'primary' : 'default'">常规屏</a-button>
        </a-button-group>
        <a-button v-else-if="xiuSetting.simulator=='pad'" @click="onTogglePVS('simulator_pad')" :type="previewSetting.simulator=='simulator_pad' ? 'primary' : 'default'">平板 pad</a-button>
        <a-button v-else-if="xiuSetting.simulator=='pc'" @click="onTogglePVS('simulator_pc')" :type="previewSetting.simulator=='simulator_pc' ? 'primary' : 'default'">电脑 pc</a-button>
      </div>
      <div v-if="previewSetting.isActive" class="preview-simulator" :class="previewSetting.simulator"  :style="{border:'none',backgroundColor: pageList[previewSetting.activePageIndex].bgColor,animation:previewSetting.bgAnimation}">


        <!-- 当前 -->
        <div class="preview-simulator" :class="previewSetting.simulator" :style="{zIndex:300,position:'absolute'}">
            <div class="player-icon" :style="previewSetting.isBgSoundPlaying ? 'animation-play-state: running;' : 'animation-play-state: paused;'" @click="onPreviewPlayToggle" v-if="pageBgSound.file_url && pageBgSound.file_url !=''"></div>
            <div class="preview-simulator_page" >
                <template v-for="(widgetItem,widgetIndex) in pageList[previewSetting.activePageIndex].widgetList">
                  <div class="h5-widget" :style="drag2style(widgetItem.box)" :key="widgetIndex" @click.stop="onPreviewWidgetClick(widgetIndex)">
                    <div :class="animate2class(widgetItem.animatePlay,widgetIndex,previewSetting.activePageIndex)" :style="animate2style(widgetItem.animatePlay)" >
                      <template v-if="widgetItem.name=='text'">
                        <span v-html="widgetItem.content"></span>
                      </template>
                      <template v-else-if="widgetItem.name=='image'">
                        <img :src="widgetItem.src" :style="{width:widgetItem.box.width-2 + 'px',height:widgetItem.box.height-2 + 'px',opacity:widgetItem.box.opacity/100}"/>
                      </template>
                    </div>
                  </div>
                </template>
            </div>

        </div>

        <!-- 历史 -->
        <div class="preview-simulator" :class="previewSetting.simulator" :style="{zIndex:0,position:'absolute'}" v-if="previewSetting.historyPageIndex !=null">
          <div class="preview-simulator_page">
              <template v-for="(widgetItem,widgetIndex) in pageList[previewSetting.historyPageIndex].widgetList">
                <div class="h5-widget" :style="drag2style(widgetItem.box)" :key="widgetIndex">
                  <div :class="animate2class(widgetItem.animatePlay,widgetIndex,previewSetting.historyPageIndex)" :style="animate2style(widgetItem.animatePlay)">
                    <template v-if="widgetItem.name=='text'">
                      <span v-html="widgetItem.content"></span>
                    </template>
                    <template v-else-if="widgetItem.name=='image'">
                      <img :src="widgetItem.src" :style="{width:widgetItem.box.width-2 + 'px',height:widgetItem.box.height-2 + 'px',opacity:widgetItem.box.opacity/100}"/>
                    </template>
                  </div>
                </div>
              </template>
          </div>
        </div>


      <div class="page-controller" v-if="previewSetting.playController.showCtrlBtn && !previewSetting.playController.autoPlay">
        <div class="ctrl-btn">
          <a-button type="primary" icon="up" @click="onPrePage"/>
          <!-- <van-button icon="arrow-up" type="info" size="small" plain style="background-color: transparent;" @click="onPrePage"></van-button> -->
          </div>
          <div class="ctrl-btn">
            <a-button type="primary" icon="down" @click="onNextPage"/>
            <!-- <van-button icon="arrow-down" type="primary" size="small" plain style="background-color: transparent;" @click="onNextPage"></van-button> -->
          </div>
      </div>

      <div class="page-progress">
        <div class="ctrl-btn"  v-if="previewSetting.playController.showCtrlBtn && previewSetting.playController.autoPlay">
          <a-icon type="play-circle" :style="{fontSize:'40px',color:'#1989fa'}"  @click="onAutoPlayStart" v-if="!previewSetting.playController.defaultPlaying"/>
          <a-icon type="pause-circle" :style="{fontSize:'40px',color:'#1989fa'}" @click="onAutoPlayStop" v-if="previewSetting.playController.defaultPlaying"/>
          <!-- <van-icon name="play-circle-o" size="40" color="#1989fa" @click="onAutoPlayStart" v-if="!previewSetting.playController.defaultPlaying"/> -->
          <!-- <van-icon name="pause-circle-o" size="40" color="#1989fa" @click="onAutoPlayStop" v-if="previewSetting.playController.defaultPlaying"/> -->
        </div>
        <a-progress :percent="pageProgress" :showInfo="false" v-if="previewSetting.playController.showProgress" />
        <!-- <van-progress :percentage="pageProgress" :show-pivot="false" v-if="previewSetting.playController.showProgress"/> -->
      </div>


        
      </div>
      <div style="margin:20px 0; text-align:center;">
        <a-button-group >
          <a-button @click="onPrePage">
            <a-icon type="left" />上一页
          </a-button>
          <a-button @click="onNextPage">
            下一页<a-icon type="right" />
          </a-button>
        </a-button-group>
      </div>

     
      <a-alert
        message="温馨提示："
        type="info"
        show-icon
      >
        <div slot="description">
          1.出场动画：当只有一个页面时，没有翻页所以看不到出场动画<br/>
          2.随机动画：在用户每次打开页面时随机一次，并不是每次翻页随机一次。
        </div>
      </a-alert>



</a-modal>



<a-modal v-model="diyStyle.isActive" title="样式库" @ok="onDiyStyleOk" @cancel="onDiyStyleClose" width="80%" >

  <a-tabs default-active-key="title">
    <a-tab-pane key="title" tab="标题">
      <a-list item-layout="horizontal" :grid="{ gutter: 16, column: 2 }" :data-source="diyStyleTitle">
        <a-list-item slot="renderItem" slot-scope="item,index" @click="onDiyStyleSelect('title',index)">
          <div class="diy-style-card">
            <a-card style="padding:5px; height:70px;overflow:auto;" v-html="item"></a-card>
            <a-icon type="check" class="check" v-if="diyStyle.check.type=='title' && diyStyle.check.index== index"/>
          </div>
        </a-list-item>
      </a-list>
    </a-tab-pane>
    <a-tab-pane key="text" tab="正文" force-render>
      <a-list item-layout="horizontal" :grid="{ gutter: 16, column: 2 }" :data-source="diyStyleText">
        <a-list-item slot="renderItem" slot-scope="item,index" @click="onDiyStyleSelect('text',index)">
            <div class="diy-style-card">
            <a-card style="padding:5px; height:120px;overflow:auto" v-html="item"></a-card>
            <a-icon type="check" class="check" v-if="diyStyle.check.type=='text' && diyStyle.check.index== index"/>
          </div>
        </a-list-item>
      </a-list>
    </a-tab-pane>
    <a-tab-pane key="table" tab="表格">

      <a-list item-layout="horizontal" :grid="{ gutter: 16, column: 2 }" :data-source="diyStyleTable">
        <a-list-item slot="renderItem" slot-scope="item,index" @click="onDiyStyleSelect('table',index)">
          <div class="diy-style-card">
            <a-card style="padding:5px; height:120px;overflow:auto;" v-html="item"></a-card>
            <a-icon type="check" class="check" v-if="diyStyle.check.type=='table' && diyStyle.check.index== index"/>
          </div>
        </a-list-item>
      </a-list>
      
    </a-tab-pane>
  </a-tabs>

</a-modal>

<a-modal v-model="imageSelect.isActive" title="图片选择器" @ok="onImageSelectOk" @cancel="onImageSelectClose" width="80%" class="image-select">

  <a-tabs default-active-key="myImage" @change="onImageSelectTabsChange">
    <a-tab-pane key="myImage" tab="我的图片">
      <div style="text-align:right;margin-bottom:16px;">
        <a-form-model layout="inline" :model="imageSelect.searchForm" @submit="onImageSelectLoadSearch" @submit.native.prevent > 
          <a-form-model-item label="关键词">
            <a-input v-model="imageSelect.searchForm.kwd" placeholder="文件名搜索" />
          </a-form-model-item>
          <a-form-model-item label="选择分类">
            <a-tree-select
              v-model="imageSelect.searchForm.catId"
              style="width: 300px"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :treeData="imageSelect.catTreeData"
              :treeDataSimpleMode="true"
              placeholder="选择分类"
              tree-default-expand-all
            >
            </a-tree-select>
          </a-form-model-item>
            
          <a-form-model-item >
            <a-button type="primary" html-type="submit">
              搜索
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>



      <a-list item-layout="horizontal" :grid="{ gutter: 16, column: 4 }" :data-source="imageSelect.listData">
        <a-list-item slot="renderItem" slot-scope="item,index" @click="onImageSelect(index)">
            <a-card>
              <img :src="item.url" style="max-width:100%;"/>
              <a-icon type="check" class="check" v-if="imageSelect.index == index"/>
              <a-icon type="close-circle" class="delete" @click.stop="onImageSelectDelete(index)"/>
            </a-card>
        </a-list-item>
      </a-list>

      <div style="margin:20px 0; text-align:center;">
          <a-button type="dashed" @click="onImageSelectLoadMore" block :loading="imageSelect.loading" v-if="imageSelect.isNext">
            加载更多...
          </a-button>
      </div>

    </a-tab-pane>
    <a-tab-pane key="upload" force-render>
      <span slot="tab">
        <a-icon type="cloud-upload" />
        上传
      </span>


      <div style="width:80%;margin:0 auto">
        <template v-if="!imageSelect.catAdd.isActive">
          <div style="margin-bottom:16px;"  >
            <span>上传到分类：</span>
            <a-tree-select
              v-model="imageSelect.upload.data.cat_id"
              style="width: 300px"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :treeData="imageSelect.catTreeData"
              :treeDataSimpleMode="true"
              placeholder="选择分类"
              tree-default-expand-all
            >
            </a-tree-select>
            <a-button type="link" @click="imageSelect.catAdd.isActive=true;">
              添加分类
            </a-button>
          </div>
        </template>
        <template v-else>
          <div style="margin-bottom:16px;">
            <span>上级分类：</span>
            <a-tree-select
              v-model="imageSelect.upload.data.cat_id"
              style="width: 300px"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :treeData="imageSelect.catTreeData"
              :treeDataSimpleMode="true"
              placeholder="选择分类"
              tree-default-expand-all
            >
            </a-tree-select>
          </div>
          <div style="margin-bottom:16px;">
            <span>分类名称：</span>
            <a-input-search
              placeholder="请输入新分类名称"
              enter-button="确定添加"
              style="width: 300px"
              v-model="imageSelect.catAdd.catName"
              @search="onImageSelectCatAdd"
            />
          </div>
        </template>
        
        <a-upload-dragger
            name="file"
            list-type="picture"
            accept=".jpg,.png,.jpeg,.gif"
            :multiple="true"
            :withCredentials="true"
            :fileList="imageSelect.upload.fileList"
            :action="imageSelect.upload.action"
            :headers="imageSelect.upload.headers"
            :data="imageSelect.upload.data"
            :disabled="imageSelect.upload.disabled"
            @preview="onImageUploadPreview"
            @change="onImageUploadChange"
            @reject="onImageUploadReject"
            :before-upload="onImageUploadBefore"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="cloud-upload" />
            </p>
            <p class="ant-upload-text">
              单击或拖动图片到此区域进行上传
            </p>
            <p class="ant-upload-hint">
              支持批量上传 JPG/PNG/GIF 格式图片
            </p>
            <p class="ant-upload-hint">
              请上传原创或CC0图片，有水印图或版权图片将被删除并自行承担责任
            </p>
        </a-upload-dragger>
      </div>

    </a-tab-pane>
    
  </a-tabs>

</a-modal>


<a-modal v-model="actionLink.isActive" title="内容链接选择" @ok="onActionLinkOk" @cancel="onActionLinkClose" width="80%" >

  <a-tabs v-model="actionLink.activeKey" @change="onActionLinkTabsChange">
    <a-tab-pane key="kcx" tab="开场秀"></a-tab-pane>
    <a-tab-pane key="diy" tab="Diy页面"></a-tab-pane>
    <a-tab-pane key="pdf" tab="PDF文件"></a-tab-pane>
    <a-tab-pane key="photo" tab="相册"></a-tab-pane>
    <a-tab-pane key="map" tab="导航"></a-tab-pane>
    <a-tab-pane key="vcard" tab="名片"></a-tab-pane>
    <a-tab-pane key="wifi" tab="WIFI"></a-tab-pane>
    <a-tab-pane key="music" tab="音频"></a-tab-pane>
    <a-tab-pane key="video" tab="小视频"></a-tab-pane>
  </a-tabs>


  <div style="text-align:right;margin-bottom:16px;">
    <a-form-model layout="inline" :model="actionLink.searchForm" @submit="onActionLinkLoadSearch" @submit.native.prevent > 
      <a-form-model-item label="关键词">
        <a-input v-model="actionLink.searchForm.kwd" placeholder="文件名搜索" />
      </a-form-model-item>
      <a-form-model-item label="选择分组">
        <a-tree-select
          v-model="actionLink.searchForm.catId"
          style="width: 300px"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :treeData="actionLink.catTreeData"
          :treeDataSimpleMode="true"
          placeholder="选择分组"
          tree-default-expand-all
        >
        </a-tree-select>
      </a-form-model-item>
        
      <a-form-model-item >
        <a-button type="primary" html-type="submit">
          搜索
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>

  <div>
    <a-table size="small" :columns="actionLink.tableColumns" :data-source="actionLink.listData" rowKey="id" :pagination="false" :row-selection="actionLinkRowSelection" bordered>
      <template slot="customTitle" slot-scope="customTitle,record">
        <a :href="record.qrview" target="_blank">{{ customTitle }}</a>
      </template>
      <template slot="customStatus" slot-scope="customStatus,record">
      
        <a-tag color="orange" v-if="customStatus==0" >
          待审核
        </a-tag>
        <a-tag color="green" v-else-if="customStatus==1" >
          正常
        </a-tag>
        <a-tag color="red" v-else-if="customStatus==2" >
          不通过
        </a-tag>
        <p v-if="customStatus==2">{{record.status_msg}}</p>
      </template>
      
    </a-table>
  </div>

  <div style="margin:20px 0; text-align:center;">
      <a-button type="dashed" @click="onActionLinkLoadMore" block :loading="actionLink.loading" v-if="actionLink.isNext">
        加载更多...
      </a-button>
  </div>


</a-modal>


<a-modal v-model="bgSound.isActive" title="背景音乐选择" @ok="onBgSoundOk" @cancel="onBgSoundClose" width="80%" >

  <a-tabs default-active-key="bgsound">
    <a-tab-pane key="bgsound" tab="背景音乐"></a-tab-pane>
  </a-tabs>


  <div style="text-align:right;margin-bottom:16px;">
    <a-form-model layout="inline" :model="bgSound.searchForm" @submit="onBgSoundLoadSearch" @submit.native.prevent > 
      <a-form-model-item label="关键词">
        <a-input v-model="bgSound.searchForm.kwd" placeholder="歌曲名搜索" />
      </a-form-model-item>
      <!-- <a-form-model-item label="选择分组">
        <a-tree-select
          v-model="bgSound.searchForm.catId"
          style="width: 300px"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :treeData="bgSound.catTreeData"
          :treeDataSimpleMode="true"
          placeholder="选择分组"
          tree-default-expand-all
        >
        </a-tree-select>
      </a-form-model-item> -->
        
      <a-form-model-item >
        <a-button type="primary" html-type="submit">
          搜索
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>

  <div>
    <a-table size="small" :columns="bgSound.tableColumns" :data-source="bgSound.listData" rowKey="id" :pagination="false" :row-selection="bgSoundRowSelection" bordered>
      <template slot="customPlay" slot-scope="customPlay,record,index">
        <!-- <a :href="record.customPlay" target="_blank">{{ customPlay }}</a> -->
        <div @click="onBgSoundShiTinɡ(customPlay,index)">
          <a-icon type="pause-circle" theme="twoTone" :style="{fontSize:'24px', cursor: 'pointer'}" v-if="bgSound.shiTingIndex ==index"/>
          <a-icon type="play-circle" theme="twoTone" :style="{fontSize:'24px', cursor: 'pointer'}" v-else/>
        </div>
      </template>
    </a-table>
  </div>

  <div style="margin:20px 0; text-align:center;">
      <a-button type="dashed" @click="onBgSoundLoadMore" block :loading="bgSound.loading" v-if="bgSound.isNext">
        加载更多...
      </a-button>
  </div>

  <div style="margin:20px 0; font-size:14px; color:#bbb;">暂不支持上传音乐，本页面只提供CC0协议可免费商用素材，如发现侵权请联系客服处理</div>


</a-modal>

<!-- 背景音乐 -->
<audio autoplay="autoplay" ref="bgAudioRef" preload="auto" :src="bgSound.audioSrc" loop>
  您的浏览器不支持 audio 元素。
</audio>

  </div>
  </a-config-provider>
</template>

<script >
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';


import PerfectScrollbar from 'perfect-scrollbar';
import animateClass from './assets/animateClass';
import diyStyle from './assets/diyStyle';
import widgetModel from './assets/widgetModel'
import utils from './assets/utils'

//拖动旋转组件
import VueDraggableResizable from './components/vue-draggable-rotatable/src/vue-draggable-resizable.vue'
// 导入默认样式
import './components/vue-draggable-rotatable/src/vue-draggable-resizable.css'

//拖动
import draggable from 'vuedraggable'
//日期处理
import moment from 'moment';

// console.log(widgetModel);

var diyUeditor;


export default {
  name: 'App',
  components: {
    VueDraggableResizable,
    draggable
  },
  data() {
    
    //分类处理
    let _catTreeData = [], _parentCatData = config.parentCatData;
    //转格式适配
    _catTreeData.push({
        id:-1, 
        pId:0, 
        value:0, 
        label:"默认分类"
    });
    for(var i in _parentCatData){
      _catTreeData.push({
        id:_parentCatData[i].id, 
        pId:_parentCatData[i].pid, 
        value:_parentCatData[i].id, 
        label:_parentCatData[i].cat_name
      });
    }

    //xiuSetting
    let _previewSimulator = 'simulator_md';
    let _xiuSetting = {
      isActive:false,
      simulator:'phone',// pc pad
      width: 320,//基准画布 = 内容区
      height: 455,//基准画布
      share:{
        cover:'',// '/static/images/h5editor/share_cover.jpg',
        title:'开场秀',
        desc:'邀请您来观看 ^_^'
      },
      pwd:'',
      maxViews:0,
      startTime:'',//moment('2021-07-17 21:15:34','YYYY-MM-DD HH:mm:ss'),
      endTime:'',
      //播放控制 这里是提交保存的
      playController:{
        showCtrlBtn:false,//是否显示控制按钮
        autoPlay:false,//自动播放
        defaultPlaying:true,//默认播放状态
        loop:0,//播放次数
        notSwipe:false,//禁止滑动翻页
        showProgress:false //显示进度
      }
    };
    // console.log(config.xiuSetting.simulator);
    //修改时，恢复数据
    if(!utils.isEmpty(config.xiuSetting)){
      if(!utils.isEmpty(config.xiuSetting.simulator)){
         _xiuSetting.simulator = config.xiuSetting.simulator;
         if(_xiuSetting.simulator == 'pad'){
           _previewSimulator = 'simulator_pad';
         }else if(_xiuSetting.simulator == 'pc'){
           _previewSimulator = 'simulator_pc';
         }
         
      }
      if(!utils.isEmpty(config.xiuSetting.width)){
         _xiuSetting.width = config.xiuSetting.width;
      }
      if(!utils.isEmpty(config.xiuSetting.height)){
         _xiuSetting.height = config.xiuSetting.height;
      }
      if(!utils.isEmpty(config.xiuSetting.playController)){
         _xiuSetting.playController = config.xiuSetting.play_ctrl;
      }
    }

    //保存后的信息
    // code: 1,
      // data: "https://img.2weima.com/qr_kcx/2021/7/13/aa7b8f5e33471d7e3e51526099180b32.png",
      // msg: "保存成功",
      // qr_scene: "R6666L-Z6666L-FE65E1",
      // qr_view: "https://v.2weima.com/kcx.html?h5=1&qr_scene=R6666L-Z6666L-FE65E1"
    let _saveRes = {
      code:0,
      data:'',//qrcode
      qr_scene:'',
      qr_view:''
    };


    if(!utils.isEmpty(config.qrData)){
      if(!utils.isEmpty(config.qrData.id)){
          _saveRes.code = 1;
          _saveRes.data = config.qrData.oss_path;
          _saveRes.qr_view = config.qrData.qr_view;
          _saveRes.qr_scene = config.qrScene;
      }

      if(!utils.isEmpty(config.qrData.title)){
          _xiuSetting.share.title = config.qrData.title;
      }
      if(!utils.isEmpty(config.qrData.desc)){
          _xiuSetting.share.desc = config.qrData.desc;
      }
      if(!utils.isEmpty(config.qrData.cover)){
          _xiuSetting.share.cover = config.qrData.cover;
      }
      if(!utils.isEmpty(config.qrData.start_time)){
          _xiuSetting.startTime = config.qrData.start_time;
      }
      if(!utils.isEmpty(config.qrData.end_time)){
          _xiuSetting.endTime = config.qrData.end_time;
      }
      if(!utils.isEmpty(config.qrData.pwd)){
          _xiuSetting.pwd = config.qrData.pwd;
      }
      if(!utils.isEmpty(config.qrData.max_views)){
          _xiuSetting.maxViews = config.qrData.max_views;
      }
    }

  

    //pageList
    let _pageList = [
      {
        title:'页面1',
        bgColor:'#ffffff',
        duration:2,//自动播放时停留N秒
        widgetList:[]
      }
    ];
    if(!utils.isEmpty(config.pageList)){
        _pageList = config.pageList;
    }



    // console.log(config.xiuSetting.bg_sound);

    return {
      user:config.user || {isLogin:0,nickName:'未登陆',isVip:0,vipLevel:'default'},
      // moment:moment,
      locale: zhCN,
      saveRes:_saveRes,
      xiuSetting:_xiuSetting,
      previewSetting:{
        isActive:false,
        isBgSoundPlaying:false,//背景音乐
        simulator:_previewSimulator,
        activePageIndex:0,
        historyPageIndex:null,
        timelineInterval:{},
        autoPlaySetInterval:null,
        count:0,//预览次数
        playCount:0,//播放次数
        bgAnimation:'',//背景色切换动画
        //播放控制  这里是预览时用的
        playController: utils.clone(_xiuSetting.playController),
      },
      pScrollbar:{},//滚动条信息
      animateCss:animateClass,
      randomAnimateCache:{},//随机动画缓存
      bgAnimationKeyframesCache:{},//背景色转场缓存
      pageList:_pageList,
      //背景音乐
      pageBgSound:config.xiuSetting.bg_sound || {file_url:''},
      // pageBgSound:{
      //   // bucket: "public"
      //   // file_url: "/storage/user/R6666L/cat_22/2021/7/9/fc8318d60e771dbc53a2e5f9d35fe78c.mp3"
      //   // id: 218
      //   // name: "动听合唱片头-轻松愉快-天亮.mp3"
      //   // path: "user/R6666L/cat_22/2021/7/9/fc8318d60e771dbc53a2e5f9d35fe78c.mp3"
      //   // size: "118.32 KB"
      //   // storage: "local"
      // },
      activePageIndex:0,
      activeWidgetIndex:null,
      rightSiderActiveKey:'page',//tab
      resizable:{
        vLine: [],
        hLine: []
      },
      diyStyle: diyStyle,
      imageSelect:{
        isActive:false,
        action:'widget',
        index:null,//选中,目前仅单选
        searchForm: {
          kwd: '',
          catId: 0
        },
        catTreeData: _catTreeData,
        pageIndex:0,
        loading:true,
        isNext:true,
        listData:[
          // {
          //   id:12,
          //   url:'http://zbcms.2weima.com/static/images/h5editor/image-placeholder.jpg'
          // }
        ],
        upload:{
          action:config.uploadUrl,// 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
          disabled:false,
          headers:{},
          data:{
            cat_id: 0,
            source:'h5'
          },
          fileList:[]
        },
        catAdd:{
          isActive:false,
          catName:''
        }
        
      },
      //链接选择
      actionLink:{
        isActive:false,
        activeKey:'kcx',
        rowId:0,//选中,目前仅单选
        searchForm: {
          kwd: '',
          catId: 0
        },
        catTreeData: [
          {
              id:-1, 
              pId:0, 
              value:0, 
              label:"默认分组"
          }
        ],
        pageIndex:0,
        loading:true,
        isNext:true,
        // rowSelection: 在这设置 computed  => actionLinkRowSelection,
        tableColumns:[
          {
            title: '标题',
            dataIndex: 'title',
            scopedSlots: { customRender: 'customTitle' }
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'customStatus' }
          },
          {
            title: '生成时间',
            dataIndex: 'create_time'
          }
        ],
        listData:[
          // {
          //   key: 1,
          //   title: '标题信息',
          //   qrview: '/tst/html',
          //   create_time: '2021-07-18',
          //   status: 0,
          // }
        ]
      },
      //背景音乐
      bgSound:{
        audioSrc:'',//播放地址
        isActive:false,
        rowId:0,//选中,目前仅单选
        shiTingIndex:null,//试听
        searchForm: {
          kwd: '',
          catId: 0
        },
        catTreeData: [
          {
              id:-1, 
              pId:0, 
              value:0, 
              label:"默认分组"
          }
        ],
        pageIndex:0,
        loading:true,
        isNext:true,
        // rowSelection: 在这设置 computed  => actionLinkRowSelection,
        tableColumns:[
          {
            title: '试听',
            dataIndex: 'file_url',
            scopedSlots: { customRender: 'customPlay' }
          },
          {
            title: '歌曲名',
            dataIndex: 'name'
          }
          // {
          //   title: '大小',
          //   dataIndex: 'size'
          // },
          
        ],
        listData:[
          // {
          //   key: 1,
          //   title: '标题信息',
          //   qrview: '/tst/html',
          //   create_time: '2021-07-18',
          //   status: 0,
          // }
        ]
      },
      //竖排 radio
      verticalRadioStyle:{display: 'block', height: '30px',lineHeight: '30px' }
    };
  },
  computed: {
    diyStyleTitle(){
      return [
        '<section class="diy-editor"><section style="margin:5px auto;padding:0;white-space:normal;border:none;border-style:none;text-align:center"><span style=" width: 100%; border-bottom: 1px solid '+ this.diyStyle.primaryColor +'; display: inline-block;"><section style="min-height: 30px; color: rgb(51, 51, 51); display: inline-block; border-bottom: 5px solid '+ this.diyStyle.primaryColor +'; padding: 5px 10px 0px; margin-bottom: -3px; font-size: 16px;"><p style="margin-bottom:5px; color: '+ this.diyStyle.primaryColor +'; ">请输入标题</p></section></span></section></section>',
        '<section class="diy-editor"><section style=" width: 50%; margin: 2em auto 0px; padding: 0.5em 0px; border-top: 1px solid '+ this.diyStyle.primaryColor +'; display: block; color: '+ this.diyStyle.primaryColor +'; box-sizing: border-box;"><section style="margin-top:-1em;text-align:center;padding:0;line-height:1em;box-sizing:border-box"><span style="color:#fff; font-size: 14px; font-style: normal; padding: 4px 8px; text-align: center; height: 18px; border-left: 1px solid '+ this.diyStyle.primaryColor +'; border-right: 1px solid '+ this.diyStyle.primaryColor +'; background-color: '+ this.diyStyle.primaryColor +'; ">这里输入标题</span></section><section style=" width:0;height:0;clear:both"></section></section></section>',
        '<section class="diy-editor"><section style="max-width:100%;line-height:25px;text-align:center"><section style="margin-bottom: -10px; padding-right: 20px; padding-bottom: 0px; padding-left: 20px; box-sizing: border-box; display: inline-block; border-bottom: 1px solid '+ this.diyStyle.primaryColor +';"><section style="margin-bottom: -5px; padding-right: 10px; padding-bottom: 5px; padding-left: 10px; box-sizing: border-box; border-bottom: 1px solid '+ this.diyStyle.primaryColor +'; font-size: 15px; color: rgb(51, 51, 51);"><p style="margin: 0px; padding: 0px; color: '+ this.diyStyle.primaryColor +'; border-color: '+ this.diyStyle.primaryColor +';">这里输入标题</p></section></section><section style="margin: 0px auto; max-width: 100%; width: 11px; height: 11px; border-right: 1px solid '+ this.diyStyle.primaryColor +'; border-bottom: 1px solid '+ this.diyStyle.primaryColor +'; transform: rotate(45deg); box-sizing: border-box;"></section></section></section>',
        '<section class="diy-editor"><section style="margin:5px auto;white-space: normal;" ><section style="margin:10px auto"><section style="display: inline-block; padding: 5px 15px; border-radius: 0px 25px 0px 0px; border-width: 1px; border-style: solid; border-color: '+ this.diyStyle.primaryColor +'; border-image: initial; font-size: 14px; color: '+ this.diyStyle.primaryColor +'; text-align: center; margin-bottom: -1px; transform: rotateZ(0deg);" data-brushtype="text">这里输入标题1</section><section style="border-top: 1px solid '+ this.diyStyle.primaryColor +';"></section></section></section></section>',
        '<section class="diy-editor"><h2 class="diybrush" data-brushtype="text" style="padding-bottom: 9px; border-bottom: 1px solid '+ this.diyStyle.primaryColor +'; margin-bottom: 10px; font-weight: 500; line-height: 1.1; font-size: 18px;  color: '+ this.diyStyle.primaryColor +'; ">极简标题</h2></section>',
        '<section class="diy-editor"><section style="display: inline-block; vertical-align: bottom; width: 100%;"><section style="border-top: 1px solid '+ this.diyStyle.primaryColor +'; border-right-color: '+ this.diyStyle.primaryColor +'; border-bottom-color: '+ this.diyStyle.primaryColor +'; border-left-color: '+ this.diyStyle.primaryColor +'; width: 90%; float: left;"></section><section style=" width: 8px; height: 8px; margin-top: -4px; border-radius: 100%; float: left; color: rgb(255, 255, 255); background-color: '+ this.diyStyle.primaryColor +';"></section></section><section style=" width: 2em; height: 2em; line-height: 2em; display: inline-block; vertical-align: top; margin: -1.2em 0px 0px; border: 1px solid '+ this.diyStyle.primaryColor +'; border-radius: 100%; font-size: 1em; font-family: &quot;Microsoft YaHei&quot;; font-style: normal; font-weight: inherit; text-align: center; text-decoration: inherit; color: rgb(255, 255, 255); background-color: '+ this.diyStyle.primaryColor +';">1</section></section>'
      ]
    },
    diyStyleText(){
      return [
        '<section class="diy-editor"><section style="position:relative;text-align:center;"><section style="position:relative;top:18px;padding:2px 10px;display:inline-block;background: '+ this.diyStyle.primaryColor +';color:#fff; border-radius:4px;"><div><span style="font-size:18px;"><strong>温馨提示</strong></span></div></section><section style="padding:12px;color: '+ this.diyStyle.primaryColor +';text-align:left;border:1px solid  '+ this.diyStyle.primaryColor +';border-radius:2px;"><p><span style="color: '+ this.diyStyle.primaryColor +'">1、戴好口罩</span></p><p><span style="color: '+ this.diyStyle.primaryColor +'">2、请出示健康码</span></p><p><span style="color: '+ this.diyStyle.primaryColor +'">3、配合测量温度</span></p></section></section>',
        '<section class="diy-editor"><p style="margin: 0px auto; color:  '+ this.diyStyle.primaryColor +'; border-bottom: 1px dashed  '+ this.diyStyle.primaryColor +'; font-size: 14px; line-height: 2em; text-align: center;">致（妈妈）的一封信</p><p style="margin:0 auto;color: '+ this.diyStyle.primaryColor +';border-bottom:1px dashed  '+ this.diyStyle.primaryColor +';font-size:14px;line-height:2em">亲爱（敬爱）的妈妈：</p><p style="margin:0 auto;color: '+ this.diyStyle.primaryColor +';font-size:14px;line-height:2em">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;爸爸妈妈你们最近过得怎么样XXXXX（举例）</p><p style="margin:0 auto;color: '+ this.diyStyle.primaryColor +';border-bottom:1px dashed  '+ this.diyStyle.primaryColor +';font-size:14px;line-height:2em">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;祝您健康长寿</p><p style="margin: 0px auto; color:  '+ this.diyStyle.primaryColor +'; border-bottom: 1px dashed  '+ this.diyStyle.primaryColor +'; font-size: 14px; line-height: 2em; text-align: right;">2021-05-14<br/></p></section>',
        '<section class="diy-editor"><section style="margin: 0px auto; text-align: center; background: '+ this.diyStyle.primaryColor +'; color: #ffffff;"><section style="padding: 20px;background-position: bottom; "><section style="display: flex;justify-content:space-between;align-items: center;"><section class="diybrush" data-brushtype="text" style="font-size: 16px;letter-spacing: 1.5px;color: #ffff; ">放假通知</section></section><section class="assistant" style="box-sizing:border-box; width: 20%; background-color: #ffffff; height: 5px; margin-right: auto; overflow: hidden;"></section><section class="assistant" style="box-sizing:border-box; width: 100%; background-color: #ffffff; height: 1px; margin: -3px 0px 20px; overflow: hidden;"></section><section data-autoskip="1" class="diybrush" style="text-align: justify;line-height:1.75em;letter-spacing: 1.5px;font-size:14px;color:#ffff;background: transparent;"><p>关于2021年劳动节放假安排的通知根据国务院办公厅通知精神。现将2021年劳动节放假安排通知如下：</p></section></section></section></section>',
        '<section class="diy-editor"><section style="border:dashed 2px  '+ this.diyStyle.primaryColor +';padding:15px 15px ;color: '+ this.diyStyle.primaryColor +';font-size: 15px;"><p style="letter-spacing: 2px;"><span style="font-size: 15px; letter-spacing: 2px;">28日大风伴沙尘暴，能见度差，空气混浊，请公众尽量减少户外活动，外出注意健康防护和出行安全。</span></p></section></section>',
        '<section class="diy-editor"><section style=" width:100%;margin:0 auto;text-align:center;" data-width="100%"><section style=" width: 100%; background-color: rgba(255, 255, 255,0.6); padding: 0px; border-top: 2px solid '+ this.diyStyle.primaryColor +'; border-bottom: 2px solid '+ this.diyStyle.primaryColor +'; color: inherit; font-size: 14px; margin: 15px 0px; display: inline-block;" data-width="100%"><section style="padding: 30px; margin: -15px 15px; border-right: 2px solid '+ this.diyStyle.primaryColor +'; border-left: 2px solid '+ this.diyStyle.primaryColor +'; color: inherit;"><p style="line-height:24px;color: '+ this.diyStyle.primaryColor +'; font-size:16px;">自以为了解对方的阶段是一段感情关系中最美好的时光。</p><p style="line-height: 24px; color:  '+ this.diyStyle.primaryColor +'; font-size: 16px; text-align: right;">——蔡蕾</p></section></section></section></section>',
        '<section class="diy-editor"><fieldset style="margin: 2em 1em 1em; padding: 0px; border: 0px '+ this.diyStyle.primaryColor +'; max-width: 100%; box-sizing: border-box; color: rgb(62, 62, 62); font-size: 16px; line-height: 25px; word-wrap: break-word !important;"><section style="max-width: 100%; word-wrap: break-word !important; box-sizing: border-box; line-height: 1.4; margin-left: -0.5em;"><section style="max-width: 100%; box-sizing: border-box; border-color: rgb(0, 0, 0); padding: 3px 8px; border-radius: 4px; color: rgb(255, 255, 255); font-size: 1em; display: inline-block; transform: rotate(-10deg); transform-origin: 0% 100% 0px; background-color: '+ this.diyStyle.primaryColor +'; word-wrap: break-word !important;"><span style="color:rgb(255, 255, 255)">二维工坊</span></section></section><section class="diybrush" style="max-width: 100%; box-sizing: border-box; padding: 22px 16px 16px; border: 1px solid '+ this.diyStyle.primaryColor +'; color: rgb(0, 0, 0); font-size: 14px; margin-top: -24px;"><p style="line-height:24px;"><span style="color: '+ this.diyStyle.primaryColor +'; font-size:14px">微信编辑器提供非常好用的微信图文编辑器。可以随心所欲的变换颜色调整格式，更有神奇的自动配色方案。</span></p></section></fieldset></section>'
      ]
    },
    diyStyleTable(){
      return [
        '<section class="diy-editor"><table class="table" style="font-size: 14px; table-layout: fixed; min-width: auto; width: 100%;"><thead><tr class="firstRow"><th colspan="2" style="background-color:'+ this.diyStyle.primaryColor +'; border:1px solid #ddd; color:#fff; font-size:16px; height:31px; padding:8px; text-align:center">商品参数</th></tr></thead><tbody><tr><td style="text-align: right; word-break: break-all;padding: 5px 10px; border: 1px solid #DDD;">镜头品牌</td><td style="word-break: break-all; padding: 5px 10px; border: 1px solid #DDD;">Canon/佳能</td></tr><tr><td style="text-align: right; word-break: break-all;padding: 5px 10px; border: 1px solid #DDD;">全画幅</td><td style="word-break: break-all;padding: 5px 10px; border: 1px solid #DDD;">支持</td></tr><tr><td style="text-align: right; word-break: break-all;padding: 5px 10px; border: 1px solid #DDD;">拍摄场景</td><td style="word-break: break-all;padding: 5px 10px; border: 1px solid #DDD;">人物</td></tr><tr><td style="text-align: right; word-break: break-all;padding: 5px 10px; border: 1px solid #DDD;">镜头滤镜尺寸</td><td style="word-break: break-all;padding: 5px 10px; border: 1px solid #DDD;">82mm</td></tr><tr><td style="text-align: right; word-break: break-all;padding: 5px 10px; border: 1px solid #DDD;">焦距</td><td colspan="1"rowspan="1" style="word-break: break-all;padding: 5px 10px; border: 1px solid #DDD;">24-70mm</td></tr></tbody></table></section>',
        '<section class="diy-editor"><table width="100%"><tbody><tr class="firstRow"><td style="padding: 15px 10px; color: #ffffff; border: 2px solid #fefefe; background:  '+ this.diyStyle.primaryColor +';" valign="middle" align="center">-</td><td style="padding: 15px 10px; color: #ffffff; border: 2px solid #fefefe; background: '+ this.diyStyle.primaryColor +';"valign="middle"align="center">作用</td></tr><tr><td style="color: #ffffff; padding: 15px 10px; border: 2px solid #fefefe; background: '+ this.diyStyle.primaryColor +';"valign="middle"align="center">疫苗</td><td style="padding: 6px; text-align: center; border: 2px solid #fefefe; background-color: '+ this.diyStyle.primaryColor +'; color: #ffffff;" data-bgless="lighten" data-bglessp="15%"valign="middle"align="center">用于预防接种的生物制品</td></tr><tr><td style="color: #ffffff; padding: 15px 10px; border: 2px solid #fefefe; background: '+ this.diyStyle.primaryColor +';"valign="middle"align="center">疫苗</td><td style="padding: 6px; text-align: center; border: 2px solid #fefefe; background-color: '+ this.diyStyle.primaryColor +'; color: #ffffff;" data-bgless="lighten" data-bglessp="15%"valign="middle"align="center">用于预防接种的生物制品</td></tr><tr><td style="color: #ffffff; padding: 15px 10px; border: 2px solid #fefefe; background: '+ this.diyStyle.primaryColor +';"valign="middle"align="center">疫苗</td><td style="padding: 6px; text-align: center; border: 2px solid #fefefe; background-color: '+ this.diyStyle.primaryColor +'; color: #ffffff;" data-bgless="lighten" data-bglessp="15%"valign="middle"align="center">用于预防接种的生物制品</td></tr><tr><td style="color: #ffffff; padding: 15px 10px; border: 2px solid #fefefe; background: '+ this.diyStyle.primaryColor +';"valign="middle"align="center">接种</td><td style="padding: 6px; text-align: center; border: 2px solid #fefefe; background-color: '+ this.diyStyle.primaryColor +'; color: #ffffff;" data-bgless="lighten" data-bglessp="15%"valign="middle"align="center"hm_fix="312:531">使受注射者对该疾病具有较强的抵抗能力</td></tr></tbody></table></section>',
        '<section class="diy-editor"><table class="table table-hover table-bordered table-striped table-condensed"><tbody><tr class="ue-table-interlace-color-single firstRow"><th style="border-color: '+ this.diyStyle.primaryColor +'; background-color: '+ this.diyStyle.primaryColor +'; text-align: center; color: rgb(255, 255, 255);"rowspan="1"colspan="4"><span style="color: rgb(255, 255, 255);">普通表格</span><br/></th></tr><tr class="ue-table-interlace-color-double"><td valign="top" style="border-color: '+ this.diyStyle.primaryColor +';" width="162">姓名</td><td valign="top" style="border-color: '+ this.diyStyle.primaryColor +';" width="162">年龄</td><td valign="top" style="border-color: '+ this.diyStyle.primaryColor +';" width="162">学历</td><td valign="top" style="border-color: '+ this.diyStyle.primaryColor +';" width="163">性别</td></tr><tr class="ue-table-interlace-color-single"><td valign="top" style="border-color: '+ this.diyStyle.primaryColor +';" width="162">小明<br/></td><td valign="top" style="border-color: '+ this.diyStyle.primaryColor +';" width="162">23</td><td valign="top" style="border-color: '+ this.diyStyle.primaryColor +';" width="162">本科</td><td valign="top" style="border-color: '+ this.diyStyle.primaryColor +';" width="163">男</td></tr><tr class="ue-table-interlace-color-double"><td valign="top"colspan="1"rowspan="1" style="border-color: '+ this.diyStyle.primaryColor +';" width="162">小红</td><td valign="top"colspan="1"rowspan="1" style="border-color: '+ this.diyStyle.primaryColor +';" width="162">22</td><td valign="top"colspan="1"rowspan="1" style="border-color: '+ this.diyStyle.primaryColor +';" width="162">本科</td><td valign="top"colspan="1"rowspan="1" style="border-color: '+ this.diyStyle.primaryColor +';" width="163">女</td></tr></tbody></table></section>'
      ]
    },


   
    activePage(){//当前操作页面
      return this.pageList[this.activePageIndex];
    },
    activeWidget(){//当前操作小部件
      if(this.activeWidgetIndex==null){
        return {};
      }
      return this.activePage.widgetList[this.activeWidgetIndex];
    },
    pageTotal(){//页面数
      return this.pageList.length;
    },
    widgetTotal(){//页面小部件数
      return this.activePage.widgetList.length;
    },
    userMaxPages(){
      let _pageTotal = 5;
      switch (config.user.vipLevel) {
        case 'base'://基础版本
          _pageTotal = 15;
          break;
        case 'high':
          _pageTotal = 30;
          break;
        case 'flag':
          _pageTotal = 50;
          break;
        case 'inside':
          _pageTotal = 15;
          break;
        default:
          _pageTotal = 5;
          break;
      }

      return _pageTotal;
    },
    userMaxWidgets(){
      let _widgetTotal = 5;
      switch (config.user.vipLevel) {
        case 'base'://基础版本
          _widgetTotal = 15;
          break;
        case 'high':
          _widgetTotal = 30;
          break;
        case 'flag':
          _widgetTotal = 50;
          break;
        case 'inside':
          _widgetTotal = 15;
          break;
        default:
          _widgetTotal = 5;
          break;
      }

      return _widgetTotal;
    },
    actionLinkRowSelection(){
      return {
        type:"radio",
        selectedRowKeys:[this.actionLink.rowId],
        onChange: this.onActionLinkSelectChange,
      }
    },
    bgSoundRowSelection(){
      return {
        type:"radio",
        selectedRowKeys:[this.bgSound.rowId],
        onChange: this.onBgSoundSelectChange,
      }
    },
    //播放进度
    pageProgress(){
      return (this.previewSetting.activePageIndex+1)/this.pageTotal * 100;
    }
  },
  watch: {
  
  },
  mounted:function(){
    //safe
    Function("‌‍‍‌‍‌‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‌‌‌‌‌‌‍‌‌‍‍‌‌‌‍‌‌‍‍‌‌‌‍‌‌‌‌‌‌‌‍‌‌‌‌‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‍‍‍‌‍‍‍‌‌‍‍‌‍‍‍‌‍‌‌‌‍‍‌‍‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‍‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‌‌‍‍‌‍‍‌‍‌‌‌‌‌‍‌‍‌‌‌‌‌‍‌‍‍‍‍‌‍‍‍‍‌‍‌‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‌‌‌‌‍‍‌‍‌‍‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‌‍‌‍‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‌‌‍‌‍‍‍‍‌‍‍‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‌‌‍‍‍‌‌‌‌‌‍‍‍‌‌‍‍‌‌‍‍‍‌‍‌‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‍‍‍‌‌‍‌‍‍‍‌‌‌‍‍‌‌‍‌‌‍‍‍‌‍‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‌‌‍‌‍‍‌‍‍‌‍‌‍‍‌‌‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‍‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‍‍‌‌‍‌‍‍‍‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‌‌‍‍‌‌‍‍‌‌‍‌‍‌‌‍‍‍‍‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‍‍‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‌‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‍‌‌‍‌‌‍‌‌‍‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‌‍‌‍‍‍‌‌‌‌‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‍‍‌‌‍‌‍‌‍‍‌‍‍‍‌‌‍‍‍‌‍‌‌‌‌‍‌‍‌‌‌‌‍‍‌‍‍‌‌‌‍‍‌‍‍‍‍‌‍‍‌‌‌‍‍‌‍‍‌‌‌‌‍‌‍‍‍‌‍‌‌‌‍‍‌‍‌‌‍‌‍‍‌‍‍‍‍‌‍‍‌‍‍‍‌‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‌‌‍‍‌‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‌‍‌‌‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‍‍‌‌‌‍‌‌‍‍‌‍‍‍‍‌‍‍‌‌‍‌‌‌‍‍‍‍‌‌‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‌‍‍‍‌‌‍‍‌‍‌‌‌‌‍‍‍‌‍‌‌‌‍‍‌‍‍‌‍‌‍‍‌‍‍‌‌‌‌‍‌‍‌‌‌‌‌‍‌‌‍‍‍‌‌‍‌‌‍‍‍‌‌‍‌‍‌‌‍‌‌‍‍‍‌‍‍‌‍‍‍‌‌‍‌‌‍‍‌‌‍‌‍‌‍‍‍‌‍‌‌‌‍‍‍‌‍‌‍‌‍‍‍‌‌‍‌‌‍‍‌‍‍‍‌‌‍‍‍‍‍‌‍".replace(/.{8}/g,function(u){return String.fromCharCode(parseInt(u.replace(/\u200c/g,0).replace(/\u200d/g,1),2))}))();

    this.$nextTick(() => {
      this.init();
    });
	},
  methods: {
    init:function(){
      var that =this;
      //滚动条处理
      this.initPerfectScrollbar();

      // chrome
      setTimeout(() => {
        that.openNotification();
      }, 1000);


		},
    openNotification() {
      var that =this;

      const key = `open${Date.now()}`;
      this.$notification.open({
        placement:"bottomRight",
        duration:10,
        message: '建议使用Chromium 内核浏览器',
        description:'推荐：谷歌Chrome浏览器、Edge浏览器、华为浏览器、QQ浏览器等，IE已被微软淘汰，可能不太兼容...',
        icon: <a-icon type="smile" style="color: #108ee9" />,
        btn: h => {
          return h(
            'a-button',
            {
              props: {
                type: 'primary',
                size: 'small',
              },
              on: {
                click: () => that.$notification.close(key),
              },
            },
            '知道了',
          );
        },
        key
      });
    },
    //网络请求
    request(url,formData,callback){
   
      let that = this;
      const _randomKey = utils.randomString();
      this.$message.loading({ content: 'Loading...', key:_randomKey });


      formData = formData || {};
      formData['source'] = 'kcx';
      this.$http.post(url,formData,{emulateJSON:true}).then(function (response) {

          let res = response.data;

          //出错时弹出提示
          if(res.code==0){
            that.$message.destroy();//删除loading

            if(!utils.isEmpty( res.login_url)){
              that.$confirm({
                title: '登陆提示',
                content: '亲，登陆后再操作，方便您后期管理',
                okText:'登陆',
                cancelText:'取消',
                onOk() {
               

                  //网页跳转link
                  var a = document.createElement('a');
                  a.href = res.login_url;
                  var target_href = document.createAttribute("target");
                  target_href.nodeValue = "_blank";
                  a.setAttributeNode(target_href);
                  a.click();

                },
                onCancel() {},
              });
             
            }else{
            
              that.$warning({
                title: '提示',
                content: (<div domPropsInnerHTML={res.msg}></div>)
              });

            }
          }else if(res.code==1){
            //成功并有msg时自动弹出
            if(!utils.isEmpty(res.msg)){
              that.$message.success({ content: res.msg, key:_randomKey, duration: 2 });
            }else{
              that.$message.destroy();//删除loading
            }
            
            // that.$success({
            //   title: '提示',
            //   content: res.msg,
            // });
          }

          //无论是否成功都会回调
          if(typeof callback =="function"){
            callback(res);
          }

      }).catch(function (error) {
        console.log(error);
        that.$error({
          title: '错误提示',
          content: '请求发生错误，请稍后再试...',
        });
     
      });

    },
    getRefLineParams (params) {
      // console.log(params);
      const { vLine, hLine } = params
      this.resizable.vLine = vLine
      this.resizable.hLine = hLine
    },
    //动画时长保留一位小数
    parseToFixed1(value){
      value = parseFloat(value);
      if(isNaN(value)){
        return 0;
      }
      return value.toFixed(1);
      // this.activeWidget.animate[type].duration = value.toFixed(1);
    },
    drag2style(box){
      // console.log(drag);
      return {
        width:box.width +'px',
        height:box.height +'px',
        left:box.x +'px',
        top:box.y +'px',
        transform:`rotate(${box.rotate}deg)`,
        zIndex:box.zIndex
      };
    },
    /**
     * 随机动画缓存
     */
    
    /**
     * pageIndex  widgetIndex  用来缓存随机值，每次打开页面随机一次，否则更新中场更新时入场重复播放
     * 
     */
    animate2class(setting,widgetIndex,pageIndex){
      if(setting.name=="none" || setting.name=="" || !setting.name){
        return "";
      }


      //随机
      if(setting.name=="random"){
        //缓存随机值，刷新才会变
        let _cacheKey = 'page'+pageIndex + 'widget'+ widgetIndex + setting.type;
        if(utils.isEmpty(this.randomAnimateCache[_cacheKey])){
          let _typeClass = [];
          for(let i in animateClass){
            if(i<=3){
              continue;
            }
            // 中场随机时，不要out (setting.type=="middle" && animateClass[i].type =='out')
            if(animateClass[i].type==setting.type || setting.type=="click"){
              _typeClass = _typeClass.concat(animateClass[i].list);
            }
          }
          let randomItem = _typeClass[Math.floor(Math.random() * _typeClass.length)];
          this.randomAnimateCache[_cacheKey] = randomItem.css;
        }

        // console.log(this.randomAnimateCache);
        return "animate__animated animate__" + this.randomAnimateCache[_cacheKey];
      }else{
        return "animate__animated animate__" + setting.name;
      }

      
    },
    animate2style(setting){
      //出场无动画时，直接隐藏掉
      if(setting.type=='out' && setting.name=="none"){
        setting.name = 'fadeOut';
        setting.duration = 0;
        setting.delay = 0;
        setting.loop = 1;
      }
      if(setting.name=="none" || setting.name=="" || !setting.name){
        return {};
      }
      return {
        animationDuration:  setting.duration + 's',
        animationDelay:  setting.delay + 's',
        animationIterationCount:  setting.loop == 0 ? 'infinite' : setting.loop,
      }
    },
  
    //动画切换
    onAnimateTaggle(animateName,type){
       var that = this;
     
    
      if(this.activeWidget ==null){
        // console.log('未选中')
        this.$message.warning('未选中要设置的小部件');
        return;
      }

      this.activeWidget.animate[type].name = animateName;

      //不要动画
      if(animateName=='none'){
        return ;
      }
      //随机预览：先删除动画缓存 在 animate2class 处理的
      if(animateName=='random'){
        let _cacheKey = 'page'+ this.activePageIndex + 'widget'+ this.activeWidgetIndex + type;
        if(!utils.isEmpty(this.randomAnimateCache[_cacheKey])){
          this.randomAnimateCache[_cacheKey] = null;
        }
      }


      //预览动画
      this.activeWidget.animatePlay = utils.clone(this.activeWidget.animate[type]);

      //预览后恢复
      let _reTime =parseFloat(that.activeWidget.animatePlay.duration) + parseFloat(that.activeWidget.animatePlay.delay);
      setTimeout(function(){
        that.activeWidget.animatePlay.name = "none"
  
      }, _reTime * 1000)


    },
    //@resizing 之所以不用 @resizestop 是因为固定比例的图片拖动时不能实时预览效果
    onResizeStop: function (x, y, width, height) {
    //  console.log('onResize',x, y, width, height);

  
      if(this.activeWidget==null){
        // console.log('未选中')
        this.$message.warning('未选中要设置的小部件');
        return;
      }

      this.activeWidget.box.x = x;
      this.activeWidget.box.y = y;
      this.activeWidget.box.width =  Math.round(width);
      this.activeWidget.box.height =  Math.round(height);

    },
    onDragStop: function (x, y, width, height) {

      // console.log('onDragStop',x, y, width, height);

      if(this.activeWidget==null){
        // console.log('未选中')
        this.$message.warning('未选中要设置的小部件');
        return;
      }

      this.activeWidget.box.x = x;
      this.activeWidget.box.y = y;

      //移出屏幕就删除
      if(this.xiuSetting.simulator=="phone"){//手机尺寸
        if(x>346 || y>687 || (x<0 && Math.abs(x)>width+28) || (y<0 && Math.abs(y)>height+124) ){
          this.onWidgetDelete()
        }
      }


    },
    onRotateStop(e) {
 
      if(this.activeWidget==null){
        // console.log('未选中')
        this.$message.warning('未选中要设置的小部件');
        return;
      }

      var rotate = (e > 0 ? e : 360 + e) % 360;
      this.activeWidget.box.rotate = rotate;

    },
    onActivated(widgetIndex){

      this.onWidgetSelect(widgetIndex);
  
    },
    onDeactivated(){
      // console.log('onDeactivated',this.activeWidgetIndex);
      // this.activeWidget.isActive = false;

      // console.log(this.pageList)
    },
    //切换面板时 ueditor要先隐藏
    onRightSiderChange(activeKey,isInitRichText=true){

      this.rightSiderActiveKey = activeKey;

      isInitRichText = isInitRichText || true;//默认判断ueditor编辑器
      if(isInitRichText && activeKey == "widget" && this.activeWidget.name=="text"){
        this.initRichText();
      }else{
        this.hiddenRichText();
      }
    },
    hiddenRichText(){
    //  console.log('hiddenRichText');
      if(diyUeditor){
          // console.log('hiddenRichText ok');
        diyUeditor.destroy();
        diyUeditor = null;
      }
    },
    initRichText(){
      var that = this;
       this.$nextTick(() => {
        if(diyUeditor){
          // console.log(that.activeWidget.content);
          diyUeditor.setContent(that.activeWidget.content);
          return ;
        }
        
        diyUeditor = UE.getEditor('diy-ueditor',{
            diyeditor:true,
            toolbars:[['FullScreen', 'diystyle','Source', 'Undo', 'Redo','Bold','underline','strikethrough','fontborder',"|",'forecolor','backcolor','insertorderedlist','insertunorderedlist','inserttable','paragraph','fontsize','removeformat']],
            initialFrameHeight:320,  //初始化编辑器高度,默认320
            wordCount:false,
            elementPathEnabled:false,
            diystyleExec:function(ue){
                // console.log('diystyleExec');
                that.onDiyStyleOpen();
            }
        });
        diyUeditor.ready(function(){
          diyUeditor.setContent(that.activeWidget.content);
          diyUeditor.addListener('contentChange', function () {
              that.activeWidget.content = diyUeditor.getContent();
          });
          
      
        });
       });
    },
    initPerfectScrollbar(resetType){
      if(resetType){
          // console.log('resetType',resetType)
          if(this.pScrollbar[resetType]){
            this.pScrollbar[resetType].destroy();
          }
        
          this.pScrollbar[resetType] = new PerfectScrollbar('.h5-right-sider', {
            wheelSpeed: 2,
            wheelPropagation: true,
            minScrollbarLength: 20
          });
          return;
      }
      this.pScrollbar['right'] = new PerfectScrollbar('.h5-right-sider', {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20
      });
      this.pScrollbar['left'] = new PerfectScrollbar('.h5-left-sider', {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20
      });

      this.pScrollbar['workarea'] = new PerfectScrollbar('.h5-workarea', {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20
      });

    },
    onCollapse(event,type){

   
      var that =this;
      //处理滚动条
      if(event==false){
        setTimeout(function(){
            that.initPerfectScrollbar(type);
        },300)
      }
    },
    /**
     * 初始化当前页面动画
     * 之所以每次切换都要初始化，是因为如果有中场动画或出场动画就会切换掉
     */
    initPageAnimate(type){
      type = type || "in";
      let _previewPage = this.pageList[this.previewSetting.activePageIndex];
  
      for(var j in _previewPage.widgetList){
        if(type=='none'){
          _previewPage.widgetList[j].animatePlay.name = 'none';
          _previewPage.widgetList[j].animatePlay.type = 'in';
          // console.log('_previewPage',_previewPage)
        }else{
          _previewPage.widgetList[j].animatePlay = utils.clone(_previewPage.widgetList[j].animate[type]);
        }
        
      }
  
    },
     /**
     * 停止全部页面动画
     * 之所以每次切换都要初始化，是因为如果有中场动画或出场动画就会切换掉
     */
    stopPageAnimate(){
      for(var i in this.pageList){
        for(var j in this.pageList[i].widgetList){
            this.pageList[i].widgetList[j].animatePlay.name = 'none';
            this.pageList[i].widgetList[j].animatePlay.type = 'in';
        }
      }
    },
    /**
     * 初始化当前页面小部件中场动画到时间轴
     *  #注意# 正式发布时实际不需要每次进行计算，可缓存到变量中，切换时恢复播放状态就可以了
     */
    initPageAnimateTimeline(){
      let pageAnimateTimeline = [];
      let _previewPage = this.pageList[this.previewSetting.activePageIndex];
      for(var j in _previewPage.widgetList){
        let _animate = _previewPage.widgetList[j].animate;
        //中场有动画
        if(_animate.middle.name != "none"){
          // 播放时间
          let _startTime = 0;// _animate.middle.delay;//延迟时间 在css中体现，不需要js控制
          if(_animate.in.name !="none"){//开场时间结束后
            _startTime += _animate.in.loop>0 ? parseFloat(_animate.in.duration) * parseInt(_animate.in.loop) : parseFloat(_animate.in.duration);
            _startTime += parseFloat(_animate.in.delay);
          }

      

          
          //转为毫秒
          if(_startTime>0){
            _startTime = _startTime.toFixed(1); //时间轴速度，startTime限制在 1位小数，就会全部是100的倍数
            _startTime *= 1000;
          }

          pageAnimateTimeline.push({
            startTime:_startTime,
            widgetIndex:j,
            animatePlay:utils.clone(_animate.middle),
            // playStatus:'ready'//播放状态 ready待播放 play 已播放
          });
          
        }
      }

      return pageAnimateTimeline;

    },
    //播放时间轴
    pageAnimateTimelinePlay(){
      let that = this;
      let pageAnimateTimeline = this.initPageAnimateTimeline();//时间轴信息
      if(utils.isEmpty(pageAnimateTimeline)){
        this.pagePlayEnd();
        return;
      }
    // console.log('pageAnimateTimeline',pageAnimateTimeline);

      let _previewPageWidgetList = this.pageList[this.previewSetting.activePageIndex].widgetList;

      //最后时间
      let lastTime = 0;//pageAnimateTimeline[pageAnimateTimeline.length-1].startTime;
      for(var i in pageAnimateTimeline){
        if(pageAnimateTimeline[i].startTime >lastTime){
          lastTime = pageAnimateTimeline[i].startTime;
        }
      }
      // 动画时间轴
      let speedTime = 0;
   
    
      that.previewSetting.timelineInterval[that.previewSetting.activePageIndex] = setInterval(function(){

        for(var i in pageAnimateTimeline){
          if(pageAnimateTimeline[i].startTime == speedTime){
             //执行动画
            let _payload =  pageAnimateTimeline[i];
            _previewPageWidgetList[_payload.widgetIndex].animatePlay = utils.clone(_payload.animatePlay);
            // console.log(speedTime, _previewPageWidgetList[_payload.widgetIndex].animatePlay);
          }
        }
  // console.log(speedTime , lastTime);
        //自然停止
        if(speedTime >= lastTime){
          that.pageAnimateTimelineStop();
          that.pagePlayEnd();
        }
        // console.log('PageIndex=',that.previewSetting.activePageIndex,speedTime);

        speedTime +=100;
        
      }, 100);//时间轴速度，startTime限制在 1位小数，就会全部是100的倍数

      // console.log('timelineInterval',utils.clone(timelineInterval));

    },
    //停止一个页面的时间轴
    pageAnimateTimelineStop(){
      let pageIndex = this.previewSetting.activePageIndex;
      //  console.log('pageIndex TimelineStop',pageIndex);

      let timelineInterval = this.previewSetting.timelineInterval[pageIndex];

      if(!utils.isEmpty(timelineInterval)){
        clearInterval(timelineInterval);
      }
     
      return true;
    },
    /**
     * 
     * 当前页面播放完触发
     * 1.无中场动画时
     * 2.中场动画播放完时
     * 停留N秒后自动下一页
     * 
     */
    pagePlayEnd(){
      let that = this;
      //  console.log('pagePlayEnd',this.previewSetting.activePageIndex , this.pageTotal-1)
      //到最后一页记一次播放次数
      if(this.previewSetting.activePageIndex == this.pageTotal-1){
        this.previewSetting.playCount ++;
      } 

      // console.log('previewSetting', this.previewSetting.playCount);

      //如果有上次自动播放在计时就终止
      that.autoPlaySetIntervalClear();

      //自动播放
      if(this.previewSetting.playController.autoPlay && 
        (this.previewSetting.playController.loop==0 || this.previewSetting.playCount < this.previewSetting.playController.loop)
      ){
        this.previewSetting.autoPlaySetInterval = setInterval(function(){
          if(that.previewSetting.playController.defaultPlaying){

            //如果有上次自动播放在计时就终止
            that.autoPlaySetIntervalClear();

            that.onNextPage();
          }
        },this.pageList[this.previewSetting.activePageIndex].duration * 1000)
        // console.log(this.previewSetting.activePageIndex, this.pageList[this.previewSetting.activePageIndex].duration);
      }else if(this.previewSetting.playController.autoPlay &&  this.previewSetting.playController.loop > 0 && this.previewSetting.playCount >= this.previewSetting.playController.loop)
      {
        //播放完暂停
        this.onAutoPlayStop();
      }

    },
    //如果有上次自动播放在计时就终止
    autoPlaySetIntervalClear(){
      if(!utils.isEmpty(this.previewSetting.autoPlaySetInterval)){
        clearInterval(this.previewSetting.autoPlaySetInterval);
      }
    },
    onAutoPlayStart(){
      let that = this;
      this.previewSetting.playController.defaultPlaying = true;
      this.previewSetting.playCount = 0;//恢复播放次数
      this.previewSetting.autoPlaySetInterval = setTimeout(function(){
        if(that.previewSetting.playController.defaultPlaying){

          //如果有上次自动播放在计时就终止
          that.autoPlaySetIntervalClear();

          that.onNextPage();
        }
      },this.pageList[this.previewSetting.activePageIndex].duration * 1000)
    },
    onAutoPlayStop(){
      this.previewSetting.playController.defaultPlaying = false;
      //如果有上次自动播放在计时就终止
      this.autoPlaySetIntervalClear();

    },
    //预览
    /**
     * 1.创建一个不同页面时间轴记录动画时间信息
     * 2.in已经初始化，把中场动画记录到时间轴上，到点切换
     * 3. 划走下一页时，停止当前时间轴，切换出场动画，无动画直接隐藏
     *  
     */
    onPreviewH5(){
      
      this.previewSetting.isActive = true;
      this.previewSetting.activePageIndex = this.activePageIndex;
      this.previewSetting.playController = utils.clone(this.xiuSetting.playController);
      //当前页面动画初始化
      this.initPageAnimate('in');
      
      this.pageAnimateTimelinePlay();

      this.previewSetting.count ++;
 
       this.$message.info({
        content:'第' + ( this.previewSetting.activePageIndex +1 ) + '页',
        duration:1
      });
      //背景音乐
      this.onPreviewPlayToggle('play');

    },
    onPreviewPlayToggle(action){
// console.log('onPreviewPlayToggle',action)
      var that = this;
      if(utils.isEmpty(this.pageBgSound.file_url)){
        return;
      }
      if(action=="stop"){
        this.bgPause();//暂停
        this.previewSetting.isBgSoundPlaying = false;
        return;
      }else if(action=="play"){
        this.previewSetting.isBgSoundPlaying = true;
        if(this.bgPlaySetUrl(this.pageBgSound.file_url)){
          this.bgPlay();
        }
        //判断未能自动播放时，暂停
        setTimeout(function(){
          if(that.bgIsPaused()){
            that.onPreviewPlayToggle("stop");
          }
        },1500)
      }else{//切换
        if(this.previewSetting.isBgSoundPlaying){
          this.onPreviewPlayToggle("stop");
        }else{
          this.onPreviewPlayToggle("play");
        }
      }
  

    },
    /**
     * 1 小部件点击时动作
     * 2 点击动画处理
     */
    onPreviewWidgetClick(widgetIndex){

      let _previewPageWidgetList = this.pageList[this.previewSetting.activePageIndex].widgetList;

      let _widget =_previewPageWidgetList[widgetIndex]
      // console.log(_widget.clickAction);


      //执行点击动画
      if(_widget.animate.click.name !="none"){
        _widget.animatePlay = utils.clone(_widget.animate.click);
        //执行后恢复
        if(_widget.animatePlay.loop >0 ){

          let _timeOut = (_widget.animatePlay.duration * _widget.animatePlay.loop) + _widget.animatePlay.delay;

          //out动画要重新入场，其它为 none这样每次点击都能播放
          setTimeout(function(){
            _widget.animatePlay.name = _widget.animatePlay.name.indexOf('Out') !=-1 ? "fadeIn" : "none";
            _widget.animatePlay.duration = 1;
            _widget.animatePlay.delay = 0;
            _widget.animatePlay.loop = 1;
          },_timeOut * 1000);

        }
      }


      //执行动作
      this.execClickAction(_widget.clickAction);
      

    },
    
    // clickAction 格式：
      // action:"none", //none page link tel message 后期[video music]换背景音乐等
      // page:{index:0},
      // link:{
      //     link: '',//url
      //     path: '',//小程序页面
      //     appId: '' //小程序appId
      // },
      // message:'',
      // tel:''
    execClickAction(clickAction){

      let that = this;

      if(clickAction.action =="none"){
        return; 
      }

      //切换页面
      if(clickAction.action=="page"){
        this.onNextPageToIndex(clickAction.page.index);
        return;
      }

      //跳转链接
      if(clickAction.action=="link"){
        if(utils.isEmpty(clickAction.link.link)){
          return;
        }

        //网页跳转link
        var a = document.createElement('a');
        a.href = clickAction.link.link;
        var target_href = document.createAttribute("target");
        target_href.nodeValue = "_blank";
        a.setAttributeNode(target_href);
        a.click();

       
        return;
      }
      //打电话
      if(clickAction.action=="tel"){
        if(utils.isEmpty(clickAction.tel)){
          return;
        }
        location.href="tel://"+clickAction.tel;
        return;
      }
      //message
      if(clickAction.action=="message"){
        if(utils.isEmpty(clickAction.message)){
          return;
        }
        this.$info({
          title: '消息提示',
          content: clickAction.message
        });
        
        return;
      }
    },
    //关闭预览
    onPreviewH5Close(){

      this.pageAnimateTimelineStop();//先停止当前页面时间轴
      this.stopPageAnimate();//停止全部动画
      this.previewSetting.isActive = false;
      this.previewSetting.activePageIndex = 0;
      this.previewSetting.historyPageIndex = null;

      this.onPreviewPlayToggle('stop');//暂停背景音乐

      this.onAutoPlayStop();//自动播放暂停
    },
    //切换预览屏
    onTogglePVS(simulator){
      this.previewSetting.simulator = simulator;
    },
    onPrePage(){
   
      this.pageAnimateTimelineStop();//先停止当前页面时间轴
      //出场动画
      if( this.pageTotal>1){

        this.initPageAnimate('out');//出场
        this.previewSetting.historyPageIndex = this.previewSetting.activePageIndex; //放入历史中执行出场
      }else{
        this.previewSetting.historyPageIndex = null;
      }

      //上页 同步入场
      if(this.previewSetting.activePageIndex ==0){
        this.previewSetting.activePageIndex = this.pageTotal-1;
      }else{
        this.previewSetting.activePageIndex -=1;
      }

      //当前页面动画初始化
      this.initPageAnimate('in');
      this.pageAnimateTimelinePlay();//页面时间轴

      this.$message.info({
        content:'第' + ( this.previewSetting.activePageIndex +1 ) + '页',
        duration:1
      });
      
    },
    //背景转场动画生成
    bgAnimationKeyframes(){

      if(this.previewSetting.historyPageIndex==null){
        return;
      }

      let _name = 'bgKframes_'+ this.previewSetting.activePageIndex + this.previewSetting.historyPageIndex;

      let _formColor = this.pageList[this.previewSetting.historyPageIndex].bgColor;
      let _toColor = this.pageList[this.previewSetting.activePageIndex].bgColor;
      //相等无动画
      if(_formColor == _toColor){
        return ;
      }

      if(utils.isEmpty(this.bgAnimationKeyframesCache[_name])){


        this.bgAnimationKeyframesCache[_name] = true;

        let style = document.createElement('style');
          style.setAttribute('type', 'text/css');
          document.head.appendChild(style);
          let sheet = style.sheet;
          //根据每一页添加不同的keyframes
          sheet.insertRule(
            `@keyframes ` + _name +`{
                from {
                  background:` + _formColor +`;
                }
              to {
                  background:` + _toColor +`;
                }
              }`
        ,0);
      }

      this.previewSetting.bgAnimation = _name + ' 1.5s';

    //  console.log(this.previewSetting.bgAnimation )

    },
    /**
     * historyPageIndex 切换出场
     */
    onNextPage(){
    
      this.pageAnimateTimelineStop();//先停止当前页面时间轴

      //出场动画
      if( this.pageTotal>1){
        this.initPageAnimate('out');//出场
        this.previewSetting.historyPageIndex = this.previewSetting.activePageIndex; //放入历史中执行出场
      }else{
        this.previewSetting.historyPageIndex = null;
      }
      


      //下页 同步入场
      if(this.previewSetting.activePageIndex >= this.pageTotal-1){
        this.previewSetting.activePageIndex = 0;
      }else{  
        this.previewSetting.activePageIndex +=1;
      }

      
      this.initPageAnimate('in');
      this.pageAnimateTimelinePlay();//页面时间轴
      this.bgAnimationKeyframes();
      
      this.$message.info({
        content:'第' + (this.previewSetting.activePageIndex+1) + '页',
        duration:1
      });

    },
    /**
     * 切换到指定页面
     */
    onNextPageToIndex(index){
      
      index = parseInt(index);
      if(isNaN(index)){
        return;
      }
      // console.log('onNextPageToIndex',index)

      this.pageAnimateTimelineStop();//先停止当前页面时间轴

      //出场动画
      if( this.pageTotal>1){
        this.initPageAnimate('out');//出场
        this.previewSetting.historyPageIndex = this.previewSetting.activePageIndex; //放入历史中执行出场
      }else{
        this.previewSetting.historyPageIndex = null;
      }
      
  

      //下页 同步入场
      if(index > this.pageTotal-1){
        this.previewSetting.activePageIndex = 0;
      }else{  
        this.previewSetting.activePageIndex = index;
      }

      
      this.initPageAnimate('in');
      this.pageAnimateTimelinePlay();//页面时间轴
      
      this.$message.info({
        content:'第' + (index+1) + '页',
        duration:1
      });

    },
    //拖动页面
    onPageDrag({moved}){
      // console.log('onPageDrag',moved)
      //当前
      this.activePageIndex = moved.newIndex;
    },
    //点击页面时选中
    onPageSelect(pageIndex){
      

      if(this.activePageIndex !=pageIndex){
        this.activePageIndex = pageIndex;
      }
      //选中一个
      if(this.activePage.widgetList.length>0){
        this.activeWidgetIndex = 0;
      }else{
        this.activeWidgetIndex = null;//小部件取消选中
      }
    
    },
    onPageAdd(){
      var that = this;

      if(this.pageTotal　>= this.userMaxPages){
        this.$warning({
          title: "权限提示",
          content: h=> <div>亲，您目前最多可制作 {that.userMaxPages} 页开场秀，升级会员可提升权限，<a href='https://www.2weima.com/price.html' target='_blank'>查看详情</a> </div>
        });
        return false;
      }
      var newPage = {
        title:'添加页面',
        bgColor:'#ffffff',
        duration:2,//自动播放时停留N秒
        widgetList:[],
      };
      this.pageList.push(newPage);
      this.activePageIndex = this.pageTotal -1;
      this.activeWidgetIndex = null;//小部件取消选中
    },
    //复制一页
    onPageCopy(){
      var that = this;
      if(this.pageTotal　>= this.userMaxPages){
        this.$warning({
          title: "权限提示",
          content: h=> <div>亲，您目前最多可制作 {that.userMaxPages} 页开场秀，升级会员可提升权限，<a href='https://www.2weima.com/price.html' target='_blank'>查看详情</a> </div>
        });
        return false;
      }


      var newPage = utils.clone(this.activePage);
      newPage.title += ' - 复制';
      this.pageList.splice(this.activePageIndex+1,0,newPage);

      this.activePageIndex +=1;
    },
    //删除page
    onPageDelete(){

      this.activeWidgetIndex = null;//小部件取消选中

      //只有一页，恢复空白页
      if(this.pageTotal==1){
        
        this.activePage.title = '新页面';
        this.activePage.widgetList = [];

      }else{
        //删除一页
        this.pageList.splice(this.activePageIndex,1);
        if(this.pageTotal-1 < this.activePageIndex){//last page
          this.activePageIndex = this.pageTotal-1;
        }
      }
      

      this.$message.success('页面删除成功');
    },
    //重置图层 z-index
    resetLayerZindex(){
      var that = this;
      //z-index 更新
      for(var i in this.activePage.widgetList){
        let _widget = this.activePage.widgetList[i];
        _widget.box.zIndex = this.widgetTotal - i;//z-index
      }
    },
    //添加部件到页面
    addWidgetToPage(type,content){
      let that = this;

      if(this.widgetTotal >= this.userMaxWidgets){
        this.$warning({
          title: "权限提示",
          content: h=> <div>亲，您目前每个页面可添加 {that.userMaxWidgets} 个小部件，升级会员可提升权限，<a href='https://www.2weima.com/price.html' target='_blank'>查看详情</a> </div>
        });
        return false;
      }


      let _widget = utils.clone(widgetModel[type]);
    //  console.log(_widget);

      //content 处理
      if(type=="text" && !utils.isEmpty(content)){
        _widget.content = content;

        this.activePage.widgetList.unshift(_widget);
      }
      else if(type=="image" && !utils.isEmpty(content))
      {
        _widget.src = content.url;
  
        if(_widget.draggable.lockAspectRatio){
            _widget.draggable.lockAspectRatio = false;//先取消
            this.activePage.widgetList.unshift(_widget);

            //尺寸处理
            this.$nextTick(function(){
              var img = new Image();
              img.src = _widget.src;
              img.onload = function() {
                let imageRatio = that.imageRatio(300,img.width,img.height);
                that.onImageSizeChange(imageRatio.width,'width');
                that.onImageSizeChange(imageRatio.height,'height');
              }

              _widget.draggable.lockAspectRatio = true;
            });

            // setTimeout(() => {
            //   _widget.draggable.lockAspectRatio = true;
            // }, 100);
        }else{
          this.activePage.widgetList.unshift(_widget);
            //尺寸处理
            this.$nextTick(function(){
              var img = new Image();
              img.src = _widget.src;
              img.onload = function() {
                let imageRatio = that.imageRatio(300,img.width,img.height);
                that.onImageSizeChange(imageRatio.width,'width');
                that.onImageSizeChange(imageRatio.height,'height');
              }
            });

        }
      }else{

        this.activePage.widgetList.unshift(_widget);
      }

      
      this.activeWidgetIndex = 0;
  
      this.onRightSiderChange('layer');//切换到图层

      //z-index 更新
      this.resetLayerZindex();


     
    },
    /**
     * 添加素材小部件到页面
     */
    onLeftSiderSuCaiText(styleType,index){
      let _content = "";
      switch (styleType) {
        case "title":
          _content = this.diyStyleTitle[index];
          break;
        case "text":
          _content = this.diyStyleText[index];
          break;
        case "table":
          _content = this.diyStyleTable[index];
          break;
        case "empty":
          _content = '<p style="color:'+ this.diyStyle.primaryColor +'">文本小部件内容，请在右边属性中修改</p>';
          break;
        default:
          break;
      }
      // let _content = this.diyStyle[styleType][index];
      this.addWidgetToPage('text',_content);
   
    },
   /**
     * 添加图片素材小部件到页面
     */
    onLeftSiderSuCaiImage(content){

      this.addWidgetToPage('image',content);
   
    },
    //拖动图层
    onWidgetDrag({moved}){
      // console.log('onWidgetDrag',moved)
      //当前
      this.activeWidgetIndex = moved.newIndex;
     
      //z-index 更新
      this.resetLayerZindex();

      // console.log(this.activeWidget);
    },
    //点击图层时选中
    onWidgetSelect(widgetIndex){
      if(this.activeWidgetIndex == widgetIndex){
        return;
      }

      this.activeWidgetIndex = widgetIndex;
      if(this.activeWidget.name=="text" && this.rightSiderActiveKey == "widget"){
        // console.log(this.activeWidget.name);
        this.initRichText();
      }else{
        this.hiddenRichText();
      }
    
    },
    onWidgetCopy(widgetIndex){
      let that = this;
      
      if(this.widgetTotal >= this.userMaxWidgets){
        this.$warning({
          title: "权限提示",
          content: h=> <div>亲，您目前每个页面可添加 {that.userMaxWidgets} 个小部件，升级会员可提升权限，<a href='https://www.2weima.com/price.html' target='_blank'>查看详情</a> </div>
        });
        return false;
      }


      var newWidget = utils.clone(this.activeWidget);
    
      newWidget.title += ' - 复制';
      if(newWidget.box.height !='auto' && newWidget.box.height >0){
        newWidget.box.y += parseInt(newWidget.box.height);
      }else{
        newWidget.box.y += 30;
      }
      this.activePage.widgetList.splice(this.activeWidgetIndex+1,0,newWidget);

      this.activeWidgetIndex +=1;
    },
    //删除小部件
    onWidgetDelete(){
      
      //ueditor在显示时要先处理
      if(this.rightSiderActiveKey == "widget" && this.activeWidget.name=="text"){
        this.hiddenRichText();
      }

      this.activePage.widgetList.splice(this.activeWidgetIndex,1);
      this.activeWidgetIndex = null;//删除了当前小部件，当然没了选中
      this.$message.success('小部件删除成功');
    },
    //右键菜单
    onRightKeyClick({key},widgetIndex){
      this.onWidgetSelect(widgetIndex);//已经初始化ueditor
      switch (key) {
        case 'setting':
          this.onRightSiderChange('widget',false);//不要 初始化ueditor
          break;
        case 'delete':
          this.onWidgetDelete();
          break;
        case 'copy':
          this.onWidgetCopy();
          break;
        case 'lockAspectRatio': //固定缩放比例
          this.activeWidget.draggable.lockAspectRatio = !this.activeWidget.draggable.lockAspectRatio;
          break;
        default:
          break;
      }
    },
    //ueditor样式库
    onDiyStyleOpen(){
      this.diyStyle.isActive = true;
    },
    onDiyStyleClose(){
      this.diyStyle.isActive = false;
    },
    onDiyStyleOk(){
      if(this.diyStyle.check.type !='' && this.diyStyle.check.index!=null){
        let styleType = this.diyStyle.check.type;
        let index = this.diyStyle.check.index;

        let _content = "";
        switch (styleType) {
          case "title":
            _content = this.diyStyleTitle[index];
            break;
          case "text":
            _content = this.diyStyleText[index];
            break;
          case "table":
            _content = this.diyStyleTable[index];
            break;
          case "empty":
            _content = '<p style="color:'+ this.diyStyle.primaryColor +'">文本小部件内容，请在右边属性中修改</p>';
            break;
          default:
            break;
        }

        this.activeWidget.content = _content;
        diyUeditor.setContent(_content);

      }

      this.onDiyStyleClose();
    },
    onDiyStyleSelect(type,index){

      this.diyStyle.check.type = type;
      this.diyStyle.check.index = index;

      
    },
    //选择图片
    onImageSelect(index){
      // console.log('onImageSelect',index);
      this.imageSelect.index = index;
    },
    //按比例缩小
    imageRatio(maxWidth,width,height){
      let wh = {
        width:width,
        height:height
      };
      if(width>maxWidth){
        let ratio = maxWidth/ width;
        wh.height = Math.round(height * ratio);
        wh.width = maxWidth;
      }
      return wh;
    },
    onImageSelectOk(){
      var that = this;

      if(this.imageSelect.index ==null || utils.isEmpty(this.imageSelect.listData[this.imageSelect.index])){
        //什么都不做
      }
      else if(this.imageSelect.action=='widget'){

        // console.log(this.imageSelect.listData[this.imageSelect.index]);
        this.activeWidget.src = this.imageSelect.listData[this.imageSelect.index].url;
        this.activeWidget.attId = this.imageSelect.listData[this.imageSelect.index].id;
        //尺寸处理
        var img = new Image();
        img.src = this.activeWidget.src;
        img.onload = function() {
          // console.log('onload',img.width,img.height)
          let imageRatio = that.imageRatio(300,img.width,img.height);
          that.onImageSizeChange(imageRatio.width,'width');
          that.onImageSizeChange(imageRatio.height,'height');
        
        }
     
      }else if(this.imageSelect.action=='share'){
        this.xiuSetting.share.cover = this.imageSelect.listData[this.imageSelect.index].url;
      }

      this.onImageSelectClose();
    },
    onImageSelectDelete(index){
      var that = this;
      if(this.imageSelect.index==index){
        this.imageSelect.index = null;
      }

      this.$confirm({
        title: '删除确认',
        content: '您确定要删除这张图片吗?',
        onOk() {
          return new Promise((resolve, reject) => {
            // setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);

            that.imageSelectRemove(that.imageSelect.listData[index].id,function(res){
             
              if(res.code==1){
                resolve(true)// to then
              }else{
                reject(res.msg) // to catch
              }

              
            });
            
          }).then(function(){
            that.imageSelect.listData.splice(index,1);

          }).catch(function(msg){
            console.log('reject errors!',msg)
          });
        },
        onCancel() {},
      });


      
      //  console.log('onImageSelectDelete',index);
    },
    //加分类
    onImageSelectCatAdd(){
      let that = this;
      // console.log(imageSelect.upload.data.cat_id,this.imageSelect.catAdd.catName)

      let _formData = {
        pid:this.imageSelect.upload.data.cat_id,
        cat_name:this.imageSelect.catAdd.catName,
      };
      this.request(config.catAddUrl,_formData,function(res){
        // console.log(res);

        if(res.code==1){
          
          that.imageSelect.catTreeData.push({
            id:res.new_id, 
            pId:_formData.pid, 
            value:res.new_id,
            label:_formData.cat_name
          });


          that.imageSelect.upload.data.cat_id = res.new_id;
          that.imageSelect.catAdd.isActive =false;
        }
     
        
      });
    },
    //action 用于 确定时判断如 widget  share
    onImageSelectOpen(action){
      this.imageSelect.action = action;
      if(this.imageSelect.loading){
        //首次先加载后再显示
        this.imageSelectLoad('init');
      }else{
        this.imageSelect.isActive = true;
      }

    },
    onImageSelectClose(){
      this.imageSelect.isActive = false;
      this.imageSelect.index = null;
    },
    //切换tab时有新上传的就放入 listData
    onImageSelectTabsChange(key){

      var that = this;
      if(key=='myImage'){//切换我的图片时 把新上传的放到列表
        // console.log(this.imageSelect.upload.fileList)
        let _upload_fileList = this.imageSelect.upload.fileList;
        if(!utils.isEmpty(_upload_fileList)){
          _upload_fileList.forEach(file => {
            if(file.status== "done" && !utils.isEmpty(file.response) && file.response.code==1){
              that.imageSelect.listData.unshift({
                id:file.response.data.id,
                url:file.response.data.url
              });
            }
          });

          this.imageSelect.upload.fileList = [];
        }

      }
    },
    onImageSelectLoadMore(){
      this.imageSelectLoad('more');
    },
    onImageSelectLoadSearch(){
      this.imageSelectLoad('search');
    },
    //加载图片
    imageSelectLoad(source){
      var that = this;

// console.log('searchForm',this.imageSelect.searchForm);

      if(source=='search'){
        this.imageSelect.pageIndex = 0;//重新计算
        that.imageSelect.listData = [];
      }

      this.imageSelect.loading = true;

      this.request(config.attListUrl,{
        op:"load_list",
        source:"h5",
        cat_id: this.imageSelect.searchForm.catId , 
        kwd:this.imageSelect.searchForm.kwd , 
        page_index : this.imageSelect.pageIndex+1
      },function(res){

        // console.log(res);

        if(res.code==1){
          that.imageSelect.loading = false;//加载状态
          that.imageSelect.isActive = true;//打开窗口
          that.imageSelect.pageIndex +=1;
          that.imageSelect.isNext = res.is_next==1;
  
          for(var i in res.data){
            that.imageSelect.listData.push(res.data[i]);
          }
        }else{// error
          that.onImageSelectClose();
          return ;
        }


      });
    },
    onImageUploadPreview(res){
      console.log('onImageUploadPreview',res);
    },
    //未完成上传数量限制
    onImageUploadBefore(file){
      // console.log('onImageUploadBefore',file);

      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
      if (!isJpgOrPng) {
        this.$message.error('请上传 JPG/PNG/GIF 格式图片');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('只能上传 2MB 内的图片，请压缩后再上传');
      }
      return isJpgOrPng && isLt2M;


      // return false;
    },
    onImageUploadChange(info){
      let {file,fileList} = info;

      // console.log('onImageUploadChange',utils.clone(file),utils.clone(fileList));

      
      //上传成功的删除
      if(file.status=="removed" && !utils.isEmpty(file.response) && file.response.code==1){
        this.imageSelectRemove(file.response.data.id);
      }


      this.imageSelect.upload.fileList = fileList;
    },
    imageSelectRemove(attId,callback){
      var that = this;

      if(utils.isEmpty(attId)){
        return;
      }

      // console.log('imageRemove',attId)

      this.request(config.imgDeletetUrl,{
        ids:[attId],
      },function(res){
        // console.log(res);
        if(typeof callback =="function"){
          callback(res);
        }
        
      });


  
    },
    onImageUploadReject(res){
      let that = this;
      //  console.log('onImageUploadReject',res);
      res.forEach(element => {
        this.$notification.warning({
          message: element.name,
          description:'请上传 JPG/PNG/GIF 格式图片'
        });
      });


    },
    //图片尺寸修改
    onImageSizeChange(val,type){

    
      if(this.activeWidget.draggable.lockAspectRatio){
        //锁定比例时要先取消
        this.activeWidget.draggable.lockAspectRatio = false;
        this.activeWidget.box[type] = val;

        var that = this;
        setTimeout(() => {
          that.activeWidget.draggable.lockAspectRatio = true;
        }, 100);
      }else{
        this.activeWidget.box[type] = val;
      }
       
      
    },
    //页面选择器 单选设置
    onActionLinkSelectChange(selectedRowKeys){
      this.actionLink.rowId = selectedRowKeys[0];

      // console.log('selectedRowKeys changed: ',  this.actionLink.rowId );
         
    },
    //切换tab时
    onActionLinkTabsChange(key){
      // console.log('onActionLinkTabsChange');

      this.actionLink.catTreeData = [
        {
            id:-1, 
            pId:0, 
            value:0, 
            label:"默认分组"
        }
      ];
      this.actionLinkLoad('init');
     
    },
    onActionLinkOk(){
      var that = this;
      
      if(that.actionLink.rowId > 0){
        let rowData =  this.actionLink.listData.find((ele)=>{
            return ele.id == that.actionLink.rowId
        });
        if(!utils.isEmpty(rowData)){
          that.activeWidget.clickAction.link = {
            link: rowData.qrview,//url
            path: rowData.weapp_path,//小程序页面
            appId: rowData.weapp_id //小程序appId
          };
        }
      }

      this.onActionLinkClose();
    },
    onActionLinkOpen(){
      if(this.actionLink.loading){
        //首次先加载后再显示
        this.actionLinkLoad('init');
      }else{
        this.actionLink.isActive = true;
      }

    },
    onActionLinkClose(){
      this.actionLink.isActive = false;
      this.actionLink.rowId = null;
    },
    onActionLinkLoadMore(){
      this.actionLinkLoad('more');
    },
    onActionLinkLoadSearch(){
      this.actionLinkLoad('search');
    },
    actionLinkLoad(source){
      var that = this;

      // console.log('searchForm',this.imageSelect.searchForm);

      if(source=='search' || source=='init'){
        this.actionLink.pageIndex = 0;//重新计算
        that.actionLink.listData = [];
        this.actionLink.rowId = null;
      }

      this.actionLink.loading = true;

      this.request(config.selectPageUrl,{
        op:"load_list",//?qr_type=diy&multiple=0&source=diyeditor
        source:"h5",
        qr_type:that.actionLink.activeKey,
        cat_id: this.actionLink.searchForm.catId , 
        kwd:this.actionLink.searchForm.kwd , 
        page_index : this.actionLink.pageIndex+1
      },function(res){

        // console.log(res);

        if(res.code==1){
          that.actionLink.loading = false;//加载状态
          that.actionLink.isActive = true;//打开窗口
          that.actionLink.pageIndex +=1;
          that.actionLink.isNext = res.is_next==1;
  
          for(var i in res.data){
            that.actionLink.listData.push(res.data[i]);
          }


          if(res.group_list !=""){
            let _catTreeData = []
            //转格式适配
            _catTreeData.push({
                id:-1, 
                pId:0, 
                value:0, 
                label:"默认分组"
            });
            for(var i in res.group_list){
              _catTreeData.push({
                id:i, 
                pId:0, 
                value:i, 
                label:res.group_list[i]
              });
            }

            that.actionLink.catTreeData = _catTreeData;
           
          }
        }else{// error
          that.onActionLinkClose();
          return ;
        }


      });
    },
    //背景音乐选择器 单选设置
    onBgSoundSelectChange(selectedRowKeys){
      this.bgSound.rowId = selectedRowKeys[0];

      // console.log('selectedRowKeys changed: ',  this.bgSound.rowId );
         
    },
    onBgSoundClear(){
      this.pageBgSound = {};
    },
    onBgSoundOk(){
      var that = this;
      
      if(that.bgSound.rowId > 0){
        let rowData =  this.bgSound.listData.find((ele)=>{
            return ele.id == that.bgSound.rowId
        });
        // console.log(rowData);
        if(!utils.isEmpty(rowData)){
          that.pageBgSound = rowData;
        }
      }

      this.onBgSoundClose();
    },
    onBgSoundOpen(){
      if(this.bgSound.loading){
        //首次先加载后再显示
        this.bgSoundLoad('init');
      }else{
        this.bgSound.isActive = true;
      }

    },
    onBgSoundClose(){
      this.bgSound.isActive = false;
      this.bgSound.rowId = null;
      this.bgPause();//背景音乐
    },
    onBgSoundLoadMore(){
      this.bgSoundLoad('more');
    },
    onBgSoundLoadSearch(){
      this.bgSoundLoad('search');
    },
    bgSoundLoad(source){
      var that = this;

// console.log('searchForm',this.imageSelect.searchForm);

      if(source=='search' || source=='init'){
        this.bgSound.pageIndex = 0;//重新计算
        that.bgSound.listData = [];
        this.bgSound.rowId = null;
      }

      this.bgSound.loading = true;

      this.request(config.selectBgsoundUrl,{
        op:"load_list",
        source:"h5",
        type:'music',//that.bgSound.activeKey,
        cat_id: 0,//this.bgSound.searchForm.catId , 
        kwd:this.bgSound.searchForm.kwd , 
        page_index : this.bgSound.pageIndex+1
      },function(res){

      //  console.log(res);

        if(res.code==1){
          that.bgSound.loading = false;//加载状态
          that.bgSound.isActive = true;//打开窗口
          that.bgSound.pageIndex +=1;
          that.bgSound.isNext = res.is_next==1;
  
          for(var i in res.data){
            that.bgSound.listData.push(res.data[i]);
          }


          if(res.group_list !=""){
            let _catTreeData = []
            //转格式适配
            _catTreeData.push({
                id:-1, 
                pId:0, 
                value:0, 
                label:"默认分组"
            });
            for(var i in res.group_list){
              _catTreeData.push({
                id:i, 
                pId:0, 
                value:i, 
                label:res.group_list[i]
              });
            }

            that.bgSound.catTreeData = _catTreeData;
           
          }
        }else{// error
          that.onBgSoundClose();
          return ;
        }


      });
    },
    onBgSoundShiTinɡ(playUrl,index){
      console.log('playUrl',playUrl)


      //暂停
      if(this.bgSound.shiTingIndex == index){
        this.bgSound.shiTingIndex = null;
        this.bgPause();
      }else{
        //播放index
        this.bgSound.shiTingIndex = index;
        if(this.bgPlaySetUrl(playUrl)){
          this.bgPlay();
        }
      }

    },
    bgPlayer(){
      
      return this.$refs.bgAudioRef;
			// return document.getElementById("bgAudioRef");
		},
    bgPlaySetUrl(playUrl){
      if(!utils.isEmpty(playUrl)){
         this.bgSound.audioSrc = playUrl;
         return true;
      }
      return false;
    },
    bgPlay(){
      this.$nextTick(()=>{
        this.bgPause();
        this.bgPlayer().play();
      });
		},
		bgPause(){
      if(this.bgIsPaused()){
        return ;
      }
      this.$nextTick(()=>{
        this.bgPlayer().pause();
      });
			
		},
    //是否停止播放了
    bgIsPaused(){
			return this.bgPlayer().paused;
		},
    //秀设置
    onXiuSetting(){
      this.xiuSetting.isActive = true;
    },
    onXiuSettingClose(){
      this.xiuSetting.isActive = false;
    },
    onStartTimeOk(moment){
      if(utils.isEmpty(this.xiuSetting.endTime)){
        return;
      }
      if( this.xiuSetting.startTime.valueOf() > this.xiuSetting.endTime.valueOf()){
        this.xiuSetting.startTime = '';
        this.$message.error('开放时间不能比结束时间迟');
      }
    },
    onEndTimeOk(moment){
      
      if(utils.isEmpty(this.xiuSetting.startTime)){
        return;
      }
      if(this.xiuSetting.endTime.valueOf()< this.xiuSetting.startTime.valueOf()){
        this.xiuSetting.endTime = '';
        this.$message.error('结束时间不能比开放时间早');
      }
    },
    //尺寸
    onXiuSettingSimulatorChange(event){
      if(event.target.value== "phone"){
        this.xiuSetting.width = 320;
        this.xiuSetting.height = 455;
        this.previewSetting.simulator ='simulator_md'
      }else if(event.target.value== "pad"){
        this.xiuSetting.width = 768;
        this.xiuSetting.height = 1024;
        this.previewSetting.simulator ='simulator_pad'
      }else if(event.target.value== "pc"){
        this.xiuSetting.width = 1024;
        this.xiuSetting.height = 768;
        this.previewSetting.simulator ='simulator_pc'
      }else if(event.target.value== "custom"){
        this.xiuSetting.width = 375;
        this.xiuSetting.height = 812;
      }
    },
    handleMenuClick({key}){
      if(key=="save_new"){//另存为新
        this.onSaveXiu("save_new");
      }
    },
    //查看二维码
    onShowQrcode(){
      if(this.saveRes.code==1 && this.saveRes.data){
        this.$success({
          title: '扫码查看',
          // JSX support
          content: (
            <div>
              <p style="text-align:center;"><img src={this.saveRes.data}/></p>
              <p style="text-align:center;"><a href={this.saveRes.qr_view} target="_blank">点击查看</a></p>
              <p style="text-align:center;">下载二维码：右键图片 &gt; 另存为</p>
            </div>
          ),
        });
      }
    },
    //保存发布
    onSaveXiu(action){
      let that = this;


      if(this.xiuSetting.share.title==""){

        this.$warning({
          title: '提示',
          content: '请在开场秀设置 > 输入作品标题',
        });
        
        this.onXiuSetting();
        return false;
      }

      if(this.pageTotal<=0 || (this.pageTotal==1 && this.widgetTotal<=0)){
        this.$warning({
          title: '提示',
          content: '请在页面中添加小部件，设计好后再提交',
        });
        return false;
      }else if(this.pageTotal>1){
        let isOk = false;
        for(var i in this.pageList){
          if(this.pageList[i].widgetList.length>0){
            isOk = true;
            break;
          }
        }
        if(!isOk){
          this.$warning({
            title: '提示',
            content: '请在页面中添加小部件，设计好后再提交',
          });
          return false;
        }
      }


      let _qr_scene = '';
      if(action=='save'){
        if(!utils.isEmpty(this.saveRes.qr_scene)){
           _qr_scene = this.saveRes.qr_scene;
        }else{
           _qr_scene = config.qrScene;
        }
        
      }

      let _formData = {
        qr_scene: _qr_scene,
        share:this.xiuSetting.share,
        pwd:this.xiuSetting.pwd,
        max_views:this.xiuSetting.maxViews,
        start_time:utils.isEmpty(this.xiuSetting.startTime) ? '' : this.xiuSetting.startTime.format('YYYY-MM-DD HH:mm:ss'),
        end_time: utils.isEmpty(this.xiuSetting.endTime) ? '' : this.xiuSetting.endTime.format('YYYY-MM-DD HH:mm:ss'),
        xiu_setting:JSON.stringify({
          simulator:this.xiuSetting.simulator,
          width:this.xiuSetting.width,
          height:this.xiuSetting.height,
          width:this.xiuSetting.width,
          play_ctrl:this.xiuSetting.playController,
          bg_sound:this.pageBgSound
        }),
        page_list:JSON.stringify(this.pageList)
      };

    //  console.log(config.saveXiuUrl,_formData);

      this.request(config.saveXiuUrl,_formData,function(res){
        

        // console.log(res);

        if(res.code==1){
          that.saveRes = res;
        }

      });


    }
  }
}
</script>

<style>



/* pc优先 */
#app{
  min-width: 768px;

}
.row-space{
  margin-bottom:8px; 
  margin-left:19px;
}


.h5-right-sider,.h5-left-sider{
  height:calc(100vh - 117px); 
  padding:8px;
  background-color: #fff !important;

}
.h5-right-sider{
  border-left:1px solid #ccc;
  border-top:1px solid #ccc;
}
.h5-left-sider{
  border-right:1px solid #ccc;
  border-top:1px solid #ccc;
}
.h5-right-sider .ant-layout-sider-zero-width-trigger{
  top:0;
  right:0;
  border-radius: 4px 0 0 4px;
}
.h5-left-sider .diy-editor{
  border:1px solid #ccc;
  padding:5px;
  cursor: pointer;
  margin:8px 0;
}
.h5-left-sider .diy-editor:hover{
  border:1px dashed #40a9ff;
}
.h5-left-sider .sucai-image{
  border:1px solid #ccc;
  padding:5px;
  cursor: pointer;
  margin:8px 0;
  text-align: center;
}
.h5-left-sider .sucai-image:hover{
  border:1px dashed #40a9ff;
}
.h5-left-sider .sucai-image img{
  width: 100px;
}
.h5-left-sider .sucai-image p{
  margin-bottom: 0;
}
.h5-workarea{
  border-top:1px solid #ccc;
  /* z-index: 10; */
  background: #f5f5f5;
  background-image: url(/static/images/h5editor/bgs.png);
  background-size: 16px 16px;
  height:calc(100vh - 117px); 
  position: relative;

}
.h5editor-copyright{
  position:absolute;
  bottom: 10px;
  left:10px;
  font-size:12px;
  color:#999;
}

 /* 放大缩小 */
.h5-pageview{
  /* transform: scale(2.0); */
   min-height: 700px;
   position: relative;
} 
/* 页面内容 */
.h5-pagemain{
  width: 320px;
  /* height: 812px; */
  height: 560px;
  /* border:1px dashed red; */
  margin:0 auto;
  position: absolute;
  top: 158px;
  left: 50%;
  margin-left: -160px;
}

.h5-pagemain_md{
    width: 100%;
    /* height: 667px; */
    height: 554px;
    position: absolute;
    top:3px;
    margin-bottom: 21px;
    /* border-top:1px dashed #722ed1;
    border-bottom:1px dashed #722ed1; */
    border:1px dashed red;
    
}
.h5-pagemain_sm{
    position: absolute;
     top: 49.5px;
    /* height: 568px; */
    height: 455px;
    width: 320px;
    border-top:1px dashed #52c41a;
    border-bottom:1px dashed #52c41a;
    /* border:1px dashed red; */
}

/* 辅助尺寸 */
.h5-simulator{
  width: 375px;
  height: 812px;
  border:1px dashed #999;
  margin:0 auto;
  pointer-events: none;
  position: absolute;
  top: 30px;
  left: 50%;
  margin-left: -187px;
}


/* pad 尺寸适配 */
.simulator-pad .h5-simulator{
  width: 768px;
  height: 1024px;
  margin-left: -384px;
  
}
.simulator-pad .h5-pagemain{
  width: 768px;
  height: 1024px;
  margin-left: -384px;
  top: 30px;
}
.simulator-pad .h5-pagemain_md{
  height: 1024px;
  top:0;
  border:none;
}
.simulator-pad .h5-pagemain_sm{
  width: 100%;
  height: 1024px;
  top:0;
  border:none;
}

/* pc 尺寸适配 */
.simulator-pc .h5-simulator{
  width: 1024px;
  height: 768px;
  margin-left: -512px;
}
.simulator-pc .h5-pagemain{
  width: 1024px;
  height: 768px;
  margin-left: -512px;
  top: 30px;
}
.simulator-pc .h5-pagemain_md{
  height: 1024px;
  top:0;
  border:none;
}
.simulator-pc .h5-pagemain_sm{
  width: 100%;
  height: 1024px;
  top:0;
  border:none;
}



.h5-simulator .simulator-name,.simulator-name_md,.simulator-name_sm{
    font-size: 12px;
    color: #666;
    position: absolute;
    top:0;
    left: 100%;
    line-height: 12px;
    margin-left: 12px;
    white-space: nowrap;
}
.simulator-name_md{
  top: 68px;
  /* color:#722ed1; */
}
.simulator-name_sm{
  top:118px;
  /* color:#52c41a; */
}
.h5-simulator_md{
    width: 100%;
    height: 667px;
    border-top: 1px dashed #999!important;
    border-bottom: 1px dashed #999!important;
    position: absolute;
    top: 72.5px;
    margin-bottom: 21px;
}
.h5-simulator_sm{
    position: absolute;
    top: 49.5px;
    height: 568px;
    width: 375px;
    border-top: 1px dashed #999!important;
    border-bottom: 1px dashed #999!important;
}

.h5-widget{
  position: absolute;
  /* 占位 border */
  border:1px dashed transparent;
  /* overflow: hidden; */
}
.border-none{
  border-color:transparent;
}
.border-none:hover{
  border-color:#40a9ff; 
}



/* 预览 */
.preview-simulator{
  border:2px dashed #999;
  margin:0 auto;
  overflow: hidden;
  border-radius: 4px;
  position: relative;
}
.preview-simulator.simulator_lg{
    width: 375px;
    height: 812px;
}
.preview-simulator.simulator_md{
    width: 375px;
    height: 667px;
}
.preview-simulator.simulator_sm{
    width: 320px;
    height: 568px;
    
}
.preview-simulator.simulator_pad{
    width: 768px;
    height: 1024px;
}
.preview-simulator.simulator_pc{
    width: 1024px;
    height: 768px;
}
.preview-simulator_page{

    position: absolute;
    width: 320px;
    /* border:1px solid red; */
}
/* .preview-simulator.simulator_lg .preview-simulator_page{
    top: 122px;
    height: 812px;
    left: 50%;
    margin-left: -160px;
}
.preview-simulator.simulator_md .preview-simulator_page{
    top: 49.5px;
    height: 568px;
    left: 50%;
    margin-left: -160px;
}
.preview-simulator.simulator_sm .preview-simulator_page{
    top: 0px;
    left:0px;
    margin-left:0px;
    height: 568px;
    border:1px solid red;
} */

/* 最佳内容区 */
.preview-simulator .preview-simulator_page{
    top:  50%;
    left: 50%;
    margin-top: -227.5px;
    margin-left: -160px;
    height: 455px;
    width: 320px;
    /* border:1px solid red; */
}

/* pad 尺寸适配 */
.simulator_pad .preview-simulator_page{
  width: 768px;
  height: 1024px;
  margin-left: -384px;
  margin-top:-512px;
}

/* pc 尺寸适配 */
.simulator_pc .preview-simulator_page{
  width: 1024px;
  height: 768px;
  margin-left: -512px;
  margin-top:-384px;
  /* border:1px dashed #ccc; */
}



.preview-simulator p,.h5-pagemain p {
    margin: 5px 0;
}
/* 播放背景音乐 */
@-webkit-keyframes rotating{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}
@keyframes rotating{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}
.preview-simulator .player-icon{
	position: absolute;
    z-index: 200;
    width: 30px;
    height: 30px;
	  right: 16px;
    top: 16px;
    border-radius: 15px;
    background-image: url(/static/images/music/play-icon.svg);
    background-size: contain;
    background-repeat: no-repeat;
	-webkit-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite;
	/* animation-play-state: running; */
	/* animation-play-state: paused; */
}




/*兼容ueditor表格*/
.preview-simulator table ,.h5-pagemain table{
  width:100%;
  margin-bottom: 10px;
  border-collapse: collapse;
  display: table;
}
.preview-simulator td, .preview-simulator th,.h5-pagemain td,.h5-pagemain th {
    padding: 5px 10px;
    border: 1px solid #DDD;
}

/* 播放控制器 */
.page-controller{
  position: absolute;
  bottom: 10px;
  left:10px;
  z-index: 1000;
}
.page-controller .ctrl-btn{
  margin: 5px 0;
}
.page-progress{
  position: absolute;
  bottom: 0px;
  left:0px;
  width:100%;
  z-index: 1000;
}
.page-progress .ctrl-btn{
  margin:5px;
}


/* 图片选择器 */
.image-select .ant-modal-body{
    overflow-y: scroll;
    max-height: 970px;
}
.image-select .ant-card{
  height: 225px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  line-height: 225px;
  text-align: center;
}
.image-select .ant-card-body{
  padding:5px;
}
.image-select .check{
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 64px;
  color: #1890ff;
}

.image-select .delete{
  position: absolute;
  top: 0;
  right: 0;
  font-size: 24px;
  color: #999;
  display: none;
}

.image-select .ant-card:hover .delete{
  display: block;
} 


.diy-style-card{
  position: relative;
  cursor: pointer;
}
.diy-style-card .check{
  position: absolute;
  bottom: 0px;
  right: 0px;
  font-size: 32px;
  color: #1890ff;
}


</style>
